// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/gif;base64,R0lGODdhDAAMAIABAMzMzP///ywAAAAADAAMAAACFoQfqYeabNyDMkBQb81Uat85nxguUAEAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg height=%2739px%27 viewBox=%270 0 40 39px%27 width=%2740%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Crect x=%270%27 y=%2738px%27 width=%27100%27 height=%271%27 fill=%27%23cccccc%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* Copyright (c) Tiny Technologies, Inc. All rights reserved.
* Licensed under the LGPL or a commercial license.
* For LGPL see License.txt in the project root for license information.
* For commercial licenses see https://www.tiny.cloud/
*/
.tox {
  box-shadow: none;
  box-sizing: content-box;
  color: #222f3e;
  cursor: auto;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  vertical-align: initial;
  white-space: normal;
}
.tox :not(svg):not(rect) {
  box-sizing: inherit;
  color: inherit;
  cursor: inherit;
  direction: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  -webkit-tap-highlight-color: inherit;
  text-align: inherit;
  text-decoration: inherit;
  text-shadow: inherit;
  text-transform: inherit;
  vertical-align: inherit;
  white-space: inherit;
}
.tox :not(svg):not(rect) {
  background: 0 0;
  border: 0;
  box-shadow: none;
  float: none;
  height: auto;
  margin: 0;
  max-width: none;
  outline: 0;
  padding: 0;
  position: static;
  width: auto;
}
.tox:not([dir="rtl"]) {
  direction: ltr;
  text-align: left;
}
.tox[dir="rtl"] {
  direction: rtl;
  text-align: right;
}
.tox-tinymce {
  border: 0 solid #ccc;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;
  overflow: hidden;
  position: relative;
  visibility: inherit !important;
}
.tox-tinymce-inline {
  border: none;
  box-shadow: none;
}
.tox-tinymce-inline .tox-editor-header {
  background-color: transparent;
  border: 0 solid #ccc;
  border-radius: 0;
  box-shadow: none;
}
.tox-tinymce-aux {
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;
  z-index: 1300;
}
.tox-tinymce :focus,
.tox-tinymce-aux :focus {
  outline: 0;
}
button::-moz-focus-inner {
  border: 0;
}
.tox[dir="rtl"] .tox-icon--flip svg {
  transform: rotateY(180deg);
}
.tox .accessibility-issue__header {
  align-items: center;
  display: flex;
  margin-bottom: 4px;
}
.tox .accessibility-issue__description {
  align-items: stretch;
  border: 1px solid #ccc;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
}
.tox .accessibility-issue__description > div {
  padding-bottom: 4px;
}
.tox .accessibility-issue__description > div > div {
  align-items: center;
  display: flex;
  margin-bottom: 4px;
}
.tox .accessibility-issue__description > :last-child:not(:only-child) {
  border-color: #ccc;
  border-style: solid;
}
.tox .accessibility-issue__repair {
  margin-top: 16px;
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--info
  .accessibility-issue__description {
  background-color: rgba(32, 122, 183, 0.1);
  border-color: rgba(32, 122, 183, 0.4);
  color: #222f3e;
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--info
  .accessibility-issue__description
  > :last-child {
  border-color: rgba(32, 122, 183, 0.4);
}
.tox .tox-dialog__body-content .accessibility-issue--info .tox-form__group h2 {
  color: #207ab7;
}
.tox .tox-dialog__body-content .accessibility-issue--info .tox-icon svg {
  fill: #207ab7;
}
.tox .tox-dialog__body-content .accessibility-issue--info a .tox-icon {
  color: #207ab7;
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--warn
  .accessibility-issue__description {
  background-color: rgba(255, 165, 0, 0.1);
  border-color: rgba(255, 165, 0, 0.5);
  color: #222f3e;
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--warn
  .accessibility-issue__description
  > :last-child {
  border-color: rgba(255, 165, 0, 0.5);
}
.tox .tox-dialog__body-content .accessibility-issue--warn .tox-form__group h2 {
  color: #cc8500;
}
.tox .tox-dialog__body-content .accessibility-issue--warn .tox-icon svg {
  fill: #cc8500;
}
.tox .tox-dialog__body-content .accessibility-issue--warn a .tox-icon {
  color: #cc8500;
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--error
  .accessibility-issue__description {
  background-color: rgba(204, 0, 0, 0.1);
  border-color: rgba(204, 0, 0, 0.4);
  color: #222f3e;
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--error
  .accessibility-issue__description
  > :last-child {
  border-color: rgba(204, 0, 0, 0.4);
}
.tox .tox-dialog__body-content .accessibility-issue--error .tox-form__group h2 {
  color: #c00;
}
.tox .tox-dialog__body-content .accessibility-issue--error .tox-icon svg {
  fill: #c00;
}
.tox .tox-dialog__body-content .accessibility-issue--error a .tox-icon {
  color: #c00;
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--success
  .accessibility-issue__description {
  background-color: rgba(120, 171, 70, 0.1);
  border-color: rgba(120, 171, 70, 0.4);
  color: #222f3e;
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--success
  .accessibility-issue__description
  > :last-child {
  border-color: rgba(120, 171, 70, 0.4);
}
.tox
  .tox-dialog__body-content
  .accessibility-issue--success
  .tox-form__group
  h2 {
  color: #78ab46;
}
.tox .tox-dialog__body-content .accessibility-issue--success .tox-icon svg {
  fill: #78ab46;
}
.tox .tox-dialog__body-content .accessibility-issue--success a .tox-icon {
  color: #78ab46;
}
.tox .tox-dialog__body-content .accessibility-issue__header h1,
.tox
  .tox-dialog__body-content
  .tox-form__group
  .accessibility-issue__description
  h2 {
  margin-top: 0;
}
.tox:not([dir="rtl"])
  .tox-dialog__body-content
  .accessibility-issue__header
  .tox-button {
  margin-left: 4px;
}
.tox:not([dir="rtl"])
  .tox-dialog__body-content
  .accessibility-issue__header
  > :nth-last-child(2) {
  margin-left: auto;
}
.tox:not([dir="rtl"])
  .tox-dialog__body-content
  .accessibility-issue__description {
  padding: 4px 4px 4px 8px;
}
.tox:not([dir="rtl"])
  .tox-dialog__body-content
  .accessibility-issue__description
  > :last-child {
  border-left-width: 1px;
  padding-left: 4px;
}
.tox[dir="rtl"]
  .tox-dialog__body-content
  .accessibility-issue__header
  .tox-button {
  margin-right: 4px;
}
.tox[dir="rtl"]
  .tox-dialog__body-content
  .accessibility-issue__header
  > :nth-last-child(2) {
  margin-right: auto;
}
.tox[dir="rtl"] .tox-dialog__body-content .accessibility-issue__description {
  padding: 4px 8px 4px 4px;
}
.tox[dir="rtl"]
  .tox-dialog__body-content
  .accessibility-issue__description
  > :last-child {
  border-right-width: 1px;
  padding-right: 4px;
}
.tox .tox-anchorbar {
  display: flex;
  flex: 0 0 auto;
}
.tox .tox-bar {
  display: flex;
  flex: 0 0 auto;
}
.tox .tox-button {
  background-color: #207ab7;
  background-image: none;
  background-position: 0 0;
  background-repeat: repeat;
  border-color: #207ab7;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: normal;
  line-height: 24px;
  margin: 0;
  outline: 0;
  padding: 4px 16px;
  text-align: center;
  text-decoration: none;
  text-transform: none;
  white-space: nowrap;
}
.tox .tox-button[disabled] {
  background-color: #207ab7;
  background-image: none;
  border-color: #207ab7;
  box-shadow: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}
.tox .tox-button:focus:not(:disabled) {
  background-color: #1c6ca1;
  background-image: none;
  border-color: #1c6ca1;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button:hover:not(:disabled) {
  background-color: #1c6ca1;
  background-image: none;
  border-color: #1c6ca1;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button:active:not(:disabled) {
  background-color: #185d8c;
  background-image: none;
  border-color: #185d8c;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button--secondary {
  background-color: #f0f0f0;
  background-image: none;
  background-position: 0 0;
  background-repeat: repeat;
  border-color: #f0f0f0;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  color: #222f3e;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: normal;
  outline: 0;
  padding: 4px 16px;
  text-decoration: none;
  text-transform: none;
}
.tox .tox-button--secondary[disabled] {
  background-color: #f0f0f0;
  background-image: none;
  border-color: #f0f0f0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
}
.tox .tox-button--secondary:focus:not(:disabled) {
  background-color: #e3e3e3;
  background-image: none;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--secondary:hover:not(:disabled) {
  background-color: #e3e3e3;
  background-image: none;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--secondary:active:not(:disabled) {
  background-color: #d6d6d6;
  background-image: none;
  border-color: #d6d6d6;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--icon,
.tox .tox-button.tox-button--icon,
.tox .tox-button.tox-button--secondary.tox-button--icon {
  padding: 4px;
}
.tox .tox-button--icon .tox-icon svg,
.tox .tox-button.tox-button--icon .tox-icon svg,
.tox .tox-button.tox-button--secondary.tox-button--icon .tox-icon svg {
  display: block;
  fill: currentColor;
}
.tox .tox-button-link {
  background: 0;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;
  margin: 0;
  padding: 0;
  white-space: nowrap;
}
.tox .tox-button-link--sm {
  font-size: 14px;
}
.tox .tox-button--naked {
  background-color: transparent;
  border-color: transparent;
  box-shadow: unset;
  color: #222f3e;
}
.tox .tox-button--naked[disabled] {
  background-color: #f0f0f0;
  border-color: #f0f0f0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
}
.tox .tox-button--naked:hover:not(:disabled) {
  background-color: #e3e3e3;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--naked:focus:not(:disabled) {
  background-color: #e3e3e3;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--naked:active:not(:disabled) {
  background-color: #d6d6d6;
  border-color: #d6d6d6;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--naked .tox-icon svg {
  fill: currentColor;
}
.tox .tox-button--naked.tox-button--icon:hover:not(:disabled) {
  color: #222f3e;
}
.tox .tox-checkbox {
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  height: 36px;
  min-width: 36px;
}
.tox .tox-checkbox__input {
  height: 1px;
  overflow: hidden;
  position: absolute;
  top: auto;
  width: 1px;
}
.tox .tox-checkbox__icons {
  align-items: center;
  border-radius: 3px;
  box-shadow: 0 0 0 2px transparent;
  box-sizing: content-box;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: calc(4px - 1px);
  width: 24px;
}
.tox .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  display: block;
  fill: rgba(34, 47, 62, 0.3);
}
.tox .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {
  display: none;
  fill: #207ab7;
}
.tox .tox-checkbox__icons .tox-checkbox-icon__checked svg {
  display: none;
  fill: #207ab7;
}
.tox .tox-checkbox--disabled {
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox
  .tox-checkbox--disabled
  .tox-checkbox__icons
  .tox-checkbox-icon__checked
  svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox
  .tox-checkbox--disabled
  .tox-checkbox__icons
  .tox-checkbox-icon__unchecked
  svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox
  .tox-checkbox--disabled
  .tox-checkbox__icons
  .tox-checkbox-icon__indeterminate
  svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox
  input.tox-checkbox__input:checked
  + .tox-checkbox__icons
  .tox-checkbox-icon__unchecked
  svg {
  display: none;
}
.tox
  input.tox-checkbox__input:checked
  + .tox-checkbox__icons
  .tox-checkbox-icon__checked
  svg {
  display: block;
}
.tox
  input.tox-checkbox__input:indeterminate
  + .tox-checkbox__icons
  .tox-checkbox-icon__unchecked
  svg {
  display: none;
}
.tox
  input.tox-checkbox__input:indeterminate
  + .tox-checkbox__icons
  .tox-checkbox-icon__indeterminate
  svg {
  display: block;
}
.tox input.tox-checkbox__input:focus + .tox-checkbox__icons {
  border-radius: 3px;
  box-shadow: inset 0 0 0 1px #207ab7;
  padding: calc(4px - 1px);
}
.tox:not([dir="rtl"]) .tox-checkbox__label {
  margin-left: 4px;
}
.tox:not([dir="rtl"]) .tox-checkbox__input {
  left: -10000px;
}
.tox:not([dir="rtl"]) .tox-bar .tox-checkbox {
  margin-left: 4px;
}
.tox[dir="rtl"] .tox-checkbox__label {
  margin-right: 4px;
}
.tox[dir="rtl"] .tox-checkbox__input {
  right: -10000px;
}
.tox[dir="rtl"] .tox-bar .tox-checkbox {
  margin-right: 4px;
}
.tox .tox-collection--toolbar .tox-collection__group {
  display: flex;
  padding: 0;
}
.tox .tox-collection--grid .tox-collection__group {
  display: flex;
  flex-wrap: wrap;
  max-height: 208px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0;
}
.tox .tox-collection--list .tox-collection__group {
  border-bottom-width: 0;
  border-color: #ccc;
  border-left-width: 0;
  border-right-width: 0;
  border-style: solid;
  border-top-width: 1px;
  padding: 4px 0;
}
.tox .tox-collection--list .tox-collection__group:first-child {
  border-top-width: 0;
}
.tox .tox-collection__group-heading {
  background-color: #e6e6e6;
  color: rgba(34, 47, 62, 0.7);
  cursor: default;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 4px;
  margin-top: -4px;
  padding: 4px 8px;
  text-transform: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.tox .tox-collection__item {
  align-items: center;
  color: #222f3e;
  cursor: pointer;
  display: flex;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.tox .tox-collection--list .tox-collection__item {
  padding: 4px 8px;
}
.tox .tox-collection--toolbar .tox-collection__item {
  border-radius: 3px;
  padding: 4px;
}
.tox .tox-collection--grid .tox-collection__item {
  border-radius: 3px;
  padding: 4px;
}
.tox .tox-collection--list .tox-collection__item--enabled {
  background-color: #fff;
  color: #222f3e;
}
.tox .tox-collection--list .tox-collection__item--active {
  background-color: #dee0e2;
}
.tox .tox-collection--toolbar .tox-collection__item--enabled {
  background-color: #c8cbcf;
  color: #222f3e;
}
.tox .tox-collection--toolbar .tox-collection__item--active {
  background-color: #dee0e2;
}
.tox .tox-collection--grid .tox-collection__item--enabled {
  background-color: #c8cbcf;
  color: #222f3e;
}
.tox
  .tox-collection--grid
  .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  background-color: #dee0e2;
  color: #222f3e;
}
.tox
  .tox-collection--list
  .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  color: #222f3e;
}
.tox
  .tox-collection--toolbar
  .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  color: #222f3e;
}
.tox .tox-collection__item-checkmark,
.tox .tox-collection__item-icon {
  align-items: center;
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;
}
.tox .tox-collection__item-checkmark svg,
.tox .tox-collection__item-icon svg {
  fill: currentColor;
}
.tox .tox-collection--toolbar-lg .tox-collection__item-icon {
  height: 48px;
  width: 48px;
}
.tox .tox-collection__item-label {
  color: currentColor;
  display: inline-block;
  flex: 1;
  -ms-flex-preferred-size: auto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-transform: none;
  word-break: break-all;
}
.tox .tox-collection__item-accessory {
  color: rgba(34, 47, 62, 0.7);
  display: inline-block;
  font-size: 14px;
  height: 24px;
  line-height: 24px;
  text-transform: none;
}
.tox .tox-collection__item-caret {
  align-items: center;
  display: flex;
  min-height: 24px;
}
.tox .tox-collection__item-caret::after {
  content: "";
  font-size: 0;
  min-height: inherit;
}
.tox .tox-collection__item-caret svg {
  fill: #222f3e;
}
.tox .tox-collection__item--state-disabled {
  background-color: transparent;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-collection__item--state-disabled .tox-collection__item-caret svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox
  .tox-collection--list
  .tox-collection__item:not(.tox-collection__item--enabled)
  .tox-collection__item-checkmark
  svg {
  display: none;
}
.tox
  .tox-collection--list
  .tox-collection__item:not(.tox-collection__item--enabled)
  .tox-collection__item-accessory
  + .tox-collection__item-checkmark {
  display: none;
}
.tox .tox-collection--horizontal {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  display: flex;
  flex: 0 0 auto;
  flex-shrink: 0;
  flex-wrap: nowrap;
  margin-bottom: 0;
  overflow-x: auto;
  padding: 0;
}
.tox .tox-collection--horizontal .tox-collection__group {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0 4px;
}
.tox .tox-collection--horizontal .tox-collection__item {
  height: 34px;
  margin: 2px 0 3px 0;
  padding: 0 4px;
}
.tox .tox-collection--horizontal .tox-collection__item-label {
  white-space: nowrap;
}
.tox .tox-collection--horizontal .tox-collection__item-caret {
  margin-left: 4px;
}
.tox .tox-collection__item-container {
  display: flex;
}
.tox .tox-collection__item-container--row {
  align-items: center;
  flex: 1 1 auto;
  flex-direction: row;
}
.tox
  .tox-collection__item-container--row.tox-collection__item-container--align-left {
  margin-right: auto;
}
.tox
  .tox-collection__item-container--row.tox-collection__item-container--align-right {
  justify-content: flex-end;
  margin-left: auto;
}
.tox
  .tox-collection__item-container--row.tox-collection__item-container--valign-top {
  align-items: flex-start;
  margin-bottom: auto;
}
.tox
  .tox-collection__item-container--row.tox-collection__item-container--valign-middle {
  align-items: center;
}
.tox
  .tox-collection__item-container--row.tox-collection__item-container--valign-bottom {
  align-items: flex-end;
  margin-top: auto;
}
.tox .tox-collection__item-container--column {
  -ms-grid-row-align: center;
  align-self: center;
  flex: 1 1 auto;
  flex-direction: column;
}
.tox
  .tox-collection__item-container--column.tox-collection__item-container--align-left {
  align-items: flex-start;
}
.tox
  .tox-collection__item-container--column.tox-collection__item-container--align-right {
  align-items: flex-end;
}
.tox
  .tox-collection__item-container--column.tox-collection__item-container--valign-top {
  align-self: flex-start;
}
.tox
  .tox-collection__item-container--column.tox-collection__item-container--valign-middle {
  -ms-grid-row-align: center;
  align-self: center;
}
.tox
  .tox-collection__item-container--column.tox-collection__item-container--valign-bottom {
  align-self: flex-end;
}
.tox:not([dir="rtl"])
  .tox-collection--horizontal
  .tox-collection__group:not(:last-of-type) {
  border-right: 1px solid #ccc;
}
.tox:not([dir="rtl"])
  .tox-collection--list
  .tox-collection__item
  > :not(:first-child) {
  margin-left: 8px;
}
.tox:not([dir="rtl"])
  .tox-collection--list
  .tox-collection__item
  > .tox-collection__item-label:first-child {
  margin-left: 4px;
}
.tox:not([dir="rtl"]) .tox-collection__item-accessory {
  margin-left: 16px;
  text-align: right;
}
.tox:not([dir="rtl"]) .tox-collection .tox-collection__item-caret {
  margin-left: 16px;
}
.tox[dir="rtl"]
  .tox-collection--horizontal
  .tox-collection__group:not(:last-of-type) {
  border-left: 1px solid #ccc;
}
.tox[dir="rtl"]
  .tox-collection--list
  .tox-collection__item
  > :not(:first-child) {
  margin-right: 8px;
}
.tox[dir="rtl"]
  .tox-collection--list
  .tox-collection__item
  > .tox-collection__item-label:first-child {
  margin-right: 4px;
}
.tox[dir="rtl"] .tox-collection__item-accessory {
  margin-right: 16px;
  text-align: left;
}
.tox[dir="rtl"] .tox-collection .tox-collection__item-caret {
  margin-right: 16px;
  transform: rotateY(180deg);
}
.tox[dir="rtl"] .tox-collection--horizontal .tox-collection__item-caret {
  margin-right: 4px;
}
.tox .tox-color-picker-container {
  display: flex;
  flex-direction: row;
  height: 225px;
  margin: 0;
}
.tox .tox-sv-palette {
  box-sizing: border-box;
  display: flex;
  height: 100%;
}
.tox .tox-sv-palette-spectrum {
  height: 100%;
}
.tox .tox-sv-palette,
.tox .tox-sv-palette-spectrum {
  width: 225px;
}
.tox .tox-sv-palette-thumb {
  background: 0 0;
  border: 1px solid #000;
  border-radius: 50%;
  box-sizing: content-box;
  height: 12px;
  position: absolute;
  width: 12px;
}
.tox .tox-sv-palette-inner-thumb {
  border: 1px solid #fff;
  border-radius: 50%;
  height: 10px;
  position: absolute;
  width: 10px;
}
.tox .tox-hue-slider {
  box-sizing: border-box;
  height: 100%;
  width: 25px;
}
.tox .tox-hue-slider-spectrum {
  background: linear-gradient(
    to bottom,
    red,
    #ff0080,
    #f0f,
    #8000ff,
    #00f,
    #0080ff,
    #0ff,
    #00ff80,
    #0f0,
    #80ff00,
    #ff0,
    #ff8000,
    red
  );
  height: 100%;
  width: 100%;
}
.tox .tox-hue-slider,
.tox .tox-hue-slider-spectrum {
  width: 20px;
}
.tox .tox-hue-slider-thumb {
  background: #fff;
  border: 1px solid #000;
  box-sizing: content-box;
  height: 4px;
  width: 100%;
}
.tox .tox-rgb-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.tox .tox-rgb-form div {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  width: inherit;
}
.tox .tox-rgb-form input {
  width: 6em;
}
.tox .tox-rgb-form input.tox-invalid {
  border: 1px solid red !important;
}
.tox .tox-rgb-form .tox-rgba-preview {
  border: 1px solid #000;
  flex-grow: 2;
  margin-bottom: 0;
}
.tox:not([dir="rtl"]) .tox-sv-palette {
  margin-right: 15px;
}
.tox:not([dir="rtl"]) .tox-hue-slider {
  margin-right: 15px;
}
.tox:not([dir="rtl"]) .tox-hue-slider-thumb {
  margin-left: -1px;
}
.tox:not([dir="rtl"]) .tox-rgb-form label {
  margin-right: 0.5em;
}
.tox[dir="rtl"] .tox-sv-palette {
  margin-left: 15px;
}
.tox[dir="rtl"] .tox-hue-slider {
  margin-left: 15px;
}
.tox[dir="rtl"] .tox-hue-slider-thumb {
  margin-right: -1px;
}
.tox[dir="rtl"] .tox-rgb-form label {
  margin-left: 0.5em;
}
.tox .tox-toolbar .tox-swatches,
.tox .tox-toolbar__overflow .tox-swatches,
.tox .tox-toolbar__primary .tox-swatches {
  margin: 2px 0 3px 4px;
}
.tox .tox-collection--list .tox-collection__group .tox-swatches-menu {
  border: 0;
  margin: -4px 0;
}
.tox .tox-swatches__row {
  display: flex;
}
.tox .tox-swatch {
  height: 30px;
  transition:
    transform 0.15s,
    box-shadow 0.15s;
  width: 30px;
}
.tox .tox-swatch:focus,
.tox .tox-swatch:hover {
  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.3) inset;
  transform: scale(0.8);
}
.tox .tox-swatch--remove {
  align-items: center;
  display: flex;
  justify-content: center;
}
.tox .tox-swatch--remove svg path {
  stroke: #e74c3c;
}
.tox .tox-swatches__picker-btn {
  align-items: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 30px;
  justify-content: center;
  outline: 0;
  padding: 0;
  width: 30px;
}
.tox .tox-swatches__picker-btn svg {
  height: 24px;
  width: 24px;
}
.tox .tox-swatches__picker-btn:hover {
  background: #dee0e2;
}
.tox:not([dir="rtl"]) .tox-swatches__picker-btn {
  margin-left: auto;
}
.tox[dir="rtl"] .tox-swatches__picker-btn {
  margin-right: auto;
}
.tox .tox-comment-thread {
  background: #fff;
  position: relative;
}
.tox .tox-comment-thread > :not(:first-child) {
  margin-top: 8px;
}
.tox .tox-comment {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);
  padding: 8px 8px 16px 8px;
  position: relative;
}
.tox .tox-comment__header {
  align-items: center;
  color: #222f3e;
  display: flex;
  justify-content: space-between;
}
.tox .tox-comment__date {
  color: rgba(34, 47, 62, 0.7);
  font-size: 12px;
}
.tox .tox-comment__body {
  color: #222f3e;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  margin-top: 8px;
  position: relative;
  text-transform: initial;
}
.tox .tox-comment__body textarea {
  resize: none;
  white-space: normal;
  width: 100%;
}
.tox .tox-comment__expander {
  padding-top: 8px;
}
.tox .tox-comment__expander p {
  color: rgba(34, 47, 62, 0.7);
  font-size: 14px;
  font-style: normal;
}
.tox .tox-comment__body p {
  margin: 0;
}
.tox .tox-comment__buttonspacing {
  padding-top: 16px;
  text-align: center;
}
.tox .tox-comment-thread__overlay::after {
  background: #fff;
  bottom: 0;
  content: "";
  display: flex;
  left: 0;
  opacity: 0.9;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
}
.tox .tox-comment__reply {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 8px;
}
.tox .tox-comment__reply > :first-child {
  margin-bottom: 8px;
  width: 100%;
}
.tox .tox-comment__edit {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 16px;
}
.tox .tox-comment__gradient::after {
  background: linear-gradient(rgba(255, 255, 255, 0), #fff);
  bottom: 0;
  content: "";
  display: block;
  height: 5em;
  margin-top: -40px;
  position: absolute;
  width: 100%;
}
.tox .tox-comment__overlay {
  background: #fff;
  bottom: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  left: 0;
  opacity: 0.9;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 5;
}
.tox .tox-comment__loading-text {
  align-items: center;
  color: #222f3e;
  display: flex;
  flex-direction: column;
  position: relative;
}
.tox .tox-comment__loading-text > div {
  padding-bottom: 16px;
}
.tox .tox-comment__overlaytext {
  bottom: 0;
  flex-direction: column;
  font-size: 14px;
  left: 0;
  padding: 1em;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}
.tox .tox-comment__overlaytext p {
  background-color: #fff;
  box-shadow: 0 0 8px 8px #fff;
  color: #222f3e;
  text-align: center;
}
.tox .tox-comment__overlaytext div:nth-of-type(2) {
  font-size: 0.8em;
}
.tox .tox-comment__busy-spinner {
  align-items: center;
  background-color: #fff;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 20;
}
.tox .tox-comment__scroll {
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  overflow: auto;
}
.tox .tox-conversations {
  margin: 8px;
}
.tox:not([dir="rtl"]) .tox-comment__edit {
  margin-left: 8px;
}
.tox:not([dir="rtl"]) .tox-comment__buttonspacing > :last-child,
.tox:not([dir="rtl"]) .tox-comment__edit > :last-child,
.tox:not([dir="rtl"]) .tox-comment__reply > :last-child {
  margin-left: 8px;
}
.tox[dir="rtl"] .tox-comment__edit {
  margin-right: 8px;
}
.tox[dir="rtl"] .tox-comment__buttonspacing > :last-child,
.tox[dir="rtl"] .tox-comment__edit > :last-child,
.tox[dir="rtl"] .tox-comment__reply > :last-child {
  margin-right: 8px;
}
.tox .tox-user {
  align-items: center;
  display: flex;
}
.tox .tox-user__avatar svg {
  fill: rgba(34, 47, 62, 0.7);
}
.tox .tox-user__name {
  color: rgba(34, 47, 62, 0.7);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
}
.tox:not([dir="rtl"]) .tox-user__avatar svg {
  margin-right: 8px;
}
.tox:not([dir="rtl"]) .tox-user__avatar + .tox-user__name {
  margin-left: 8px;
}
.tox[dir="rtl"] .tox-user__avatar svg {
  margin-left: 8px;
}
.tox[dir="rtl"] .tox-user__avatar + .tox-user__name {
  margin-right: 8px;
}
.tox .tox-dialog-wrap {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1100;
}
.tox .tox-dialog-wrap__backdrop {
  background-color: rgba(255, 255, 255, 0.75);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
.tox .tox-dialog-wrap__backdrop--opaque {
  background-color: #fff;
}
.tox .tox-dialog {
  background-color: #fff;
  border-color: #ccc;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow:
    0 16px 16px -10px rgba(34, 47, 62, 0.15),
    0 0 40px 1px rgba(34, 47, 62, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 100%;
  max-width: 480px;
  overflow: hidden;
  position: relative;
  width: 95vw;
  z-index: 2;
}
@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox .tox-dialog {
    align-self: flex-start;
    margin: 8px auto;
    width: calc(100vw - 16px);
  }
}
.tox .tox-dialog-inline {
  z-index: 1100;
}
.tox .tox-dialog__header {
  align-items: center;
  background-color: #fff;
  border-bottom: none;
  color: #222f3e;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding: 8px 16px 0 16px;
  position: relative;
}
.tox .tox-dialog__header .tox-button {
  z-index: 1;
}
.tox .tox-dialog__draghandle {
  cursor: grab;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.tox .tox-dialog__draghandle:active {
  cursor: grabbing;
}
.tox .tox-dialog__dismiss {
  margin-left: auto;
}
.tox .tox-dialog__title {
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  margin: 0;
  text-transform: none;
}
.tox .tox-dialog__body {
  color: #222f3e;
  display: flex;
  flex: 1;
  -ms-flex-preferred-size: auto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  min-width: 0;
  text-align: left;
  text-transform: none;
}
@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox .tox-dialog__body {
    flex-direction: column;
  }
}
.tox .tox-dialog__body-nav {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 16px 16px;
}
@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav {
    flex-direction: row;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    padding-bottom: 0;
  }
}
.tox .tox-dialog__body-nav-item {
  border-bottom: 2px solid transparent;
  color: rgba(34, 47, 62, 0.7);
  display: inline-block;
  font-size: 14px;
  line-height: 1.3;
  margin-bottom: 8px;
  text-decoration: none;
  white-space: nowrap;
}
.tox .tox-dialog__body-nav-item:focus {
  background-color: rgba(32, 122, 183, 0.1);
}
.tox .tox-dialog__body-nav-item--active {
  border-bottom: 2px solid #207ab7;
  color: #207ab7;
}
.tox .tox-dialog__body-content {
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  -ms-flex-preferred-size: auto;
  max-height: 650px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 16px;
}
.tox .tox-dialog__body-content > * {
  margin-bottom: 0;
  margin-top: 16px;
}
.tox .tox-dialog__body-content > :first-child {
  margin-top: 0;
}
.tox .tox-dialog__body-content > :last-child {
  margin-bottom: 0;
}
.tox .tox-dialog__body-content > :only-child {
  margin-bottom: 0;
  margin-top: 0;
}
.tox .tox-dialog__body-content a {
  color: #207ab7;
  cursor: pointer;
  text-decoration: none;
}
.tox .tox-dialog__body-content a:focus,
.tox .tox-dialog__body-content a:hover {
  color: #185d8c;
  text-decoration: none;
}
.tox .tox-dialog__body-content a:active {
  color: #185d8c;
  text-decoration: none;
}
.tox .tox-dialog__body-content svg {
  fill: #222f3e;
}
.tox .tox-dialog__body-content ul {
  display: block;
  list-style-type: disc;
  margin-bottom: 16px;
  -webkit-margin-end: 0;
  margin-inline-end: 0;
  -webkit-margin-start: 0;
  margin-inline-start: 0;
  -webkit-padding-start: 2.5rem;
  padding-inline-start: 2.5rem;
}
.tox .tox-dialog__body-content .tox-form__group h1 {
  color: #222f3e;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: normal;
  margin-bottom: 16px;
  margin-top: 2rem;
  text-transform: none;
}
.tox .tox-dialog__body-content .tox-form__group h2 {
  color: #222f3e;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: normal;
  margin-bottom: 16px;
  margin-top: 2rem;
  text-transform: none;
}
.tox .tox-dialog__body-content .tox-form__group p {
  margin-bottom: 16px;
}
.tox .tox-dialog__body-content .tox-form__group h1:first-child,
.tox .tox-dialog__body-content .tox-form__group h2:first-child,
.tox .tox-dialog__body-content .tox-form__group p:first-child {
  margin-top: 0;
}
.tox .tox-dialog__body-content .tox-form__group h1:last-child,
.tox .tox-dialog__body-content .tox-form__group h2:last-child,
.tox .tox-dialog__body-content .tox-form__group p:last-child {
  margin-bottom: 0;
}
.tox .tox-dialog__body-content .tox-form__group h1:only-child,
.tox .tox-dialog__body-content .tox-form__group h2:only-child,
.tox .tox-dialog__body-content .tox-form__group p:only-child {
  margin-bottom: 0;
  margin-top: 0;
}
.tox .tox-dialog--width-lg {
  height: 650px;
  max-width: 1200px;
}
.tox .tox-dialog--width-md {
  max-width: 800px;
}
.tox .tox-dialog--width-md .tox-dialog__body-content {
  overflow: auto;
}
.tox .tox-dialog__body-content--centered {
  text-align: center;
}
.tox .tox-dialog__footer {
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
}
.tox .tox-dialog__footer-end,
.tox .tox-dialog__footer-start {
  display: flex;
}
.tox .tox-dialog__busy-spinner {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.75);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 3;
}
.tox .tox-dialog__table {
  border-collapse: collapse;
  width: 100%;
}
.tox .tox-dialog__table thead th {
  font-weight: 700;
  padding-bottom: 8px;
}
.tox .tox-dialog__table tbody tr {
  border-bottom: 1px solid #ccc;
}
.tox .tox-dialog__table tbody tr:last-child {
  border-bottom: none;
}
.tox .tox-dialog__table td {
  padding-bottom: 8px;
  padding-top: 8px;
}
.tox .tox-dialog__popups {
  position: absolute;
  width: 100%;
  z-index: 1100;
}
.tox .tox-dialog__body-iframe {
  display: flex;
  flex: 1;
  flex-direction: column;
  -ms-flex-preferred-size: auto;
}
.tox .tox-dialog__body-iframe .tox-navobj {
  display: flex;
  flex: 1;
  -ms-flex-preferred-size: auto;
}
.tox .tox-dialog__body-iframe .tox-navobj :nth-child(2) {
  flex: 1;
  -ms-flex-preferred-size: auto;
  height: 100%;
}
.tox .tox-dialog-dock-fadeout {
  opacity: 0;
  visibility: hidden;
}
.tox .tox-dialog-dock-fadein {
  opacity: 1;
  visibility: visible;
}
.tox .tox-dialog-dock-transition {
  transition:
    visibility 0s linear 0.3s,
    opacity 0.3s ease;
}
.tox .tox-dialog-dock-transition.tox-dialog-dock-fadein {
  transition-delay: 0s;
}
.tox.tox-platform-ie .tox-dialog-wrap {
  position: -ms-device-fixed;
}
@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox:not([dir="rtl"]) .tox-dialog__body-nav {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop)
    .tox:not([dir="rtl"])
    .tox-dialog__body-nav-item:not(:first-child) {
    margin-left: 8px;
  }
}
.tox:not([dir="rtl"]) .tox-dialog__footer .tox-dialog__footer-end > *,
.tox:not([dir="rtl"]) .tox-dialog__footer .tox-dialog__footer-start > * {
  margin-left: 8px;
}
.tox[dir="rtl"] .tox-dialog__body {
  text-align: right;
}
@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox[dir="rtl"] .tox-dialog__body-nav {
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop)
    .tox[dir="rtl"]
    .tox-dialog__body-nav-item:not(:first-child) {
    margin-right: 8px;
  }
}
.tox[dir="rtl"] .tox-dialog__footer .tox-dialog__footer-end > *,
.tox[dir="rtl"] .tox-dialog__footer .tox-dialog__footer-start > * {
  margin-right: 8px;
}
body.tox-dialog__disable-scroll {
  overflow: hidden;
}
.tox .tox-dropzone-container {
  display: flex;
  flex: 1;
  -ms-flex-preferred-size: auto;
}
.tox .tox-dropzone {
  align-items: center;
  background: #fff;
  border: 2px dashed #ccc;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  min-height: 100px;
  padding: 10px;
}
.tox .tox-dropzone p {
  color: rgba(34, 47, 62, 0.7);
  margin: 0 0 16px 0;
}
.tox .tox-edit-area {
  display: flex;
  flex: 1;
  -ms-flex-preferred-size: auto;
  overflow: hidden;
  position: relative;
}
.tox .tox-edit-area__iframe {
  background-color: #fff;
  border: 0;
  box-sizing: border-box;
  flex: 1;
  -ms-flex-preferred-size: auto;
  height: 100%;
  position: absolute;
  width: 100%;
}
.tox.tox-inline-edit-area {
  border: 1px dotted #ccc;
}
.tox .tox-editor-container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}
.tox .tox-editor-header {
  z-index: 1;
}
.tox:not(.tox-tinymce-inline) .tox-editor-header {
  box-shadow: none;
  transition: box-shadow 0.5s;
}
.tox.tox-tinymce--toolbar-bottom .tox-editor-header,
.tox.tox-tinymce-inline .tox-editor-header {
  margin-bottom: -1px;
}
.tox.tox-tinymce--toolbar-sticky-on .tox-editor-header {
  background-color: transparent;
  box-shadow: 0 4px 4px -3px rgba(0, 0, 0, 0.25);
}
.tox-editor-dock-fadeout {
  opacity: 0;
  visibility: hidden;
}
.tox-editor-dock-fadein {
  opacity: 1;
  visibility: visible;
}
.tox-editor-dock-transition {
  transition:
    visibility 0s linear 0.25s,
    opacity 0.25s ease;
}
.tox-editor-dock-transition.tox-editor-dock-fadein {
  transition-delay: 0s;
}
.tox .tox-control-wrap {
  flex: 1;
  position: relative;
}
.tox
  .tox-control-wrap:not(.tox-control-wrap--status-invalid)
  .tox-control-wrap__status-icon-invalid,
.tox
  .tox-control-wrap:not(.tox-control-wrap--status-unknown)
  .tox-control-wrap__status-icon-unknown,
.tox
  .tox-control-wrap:not(.tox-control-wrap--status-valid)
  .tox-control-wrap__status-icon-valid {
  display: none;
}
.tox .tox-control-wrap svg {
  display: block;
}
.tox .tox-control-wrap__status-icon-wrap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.tox .tox-control-wrap__status-icon-invalid svg {
  fill: #c00;
}
.tox .tox-control-wrap__status-icon-unknown svg {
  fill: orange;
}
.tox .tox-control-wrap__status-icon-valid svg {
  fill: green;
}
.tox:not([dir="rtl"]) .tox-control-wrap--status-invalid .tox-textfield,
.tox:not([dir="rtl"]) .tox-control-wrap--status-unknown .tox-textfield,
.tox:not([dir="rtl"]) .tox-control-wrap--status-valid .tox-textfield {
  padding-right: 32px;
}
.tox:not([dir="rtl"]) .tox-control-wrap__status-icon-wrap {
  right: 4px;
}
.tox[dir="rtl"] .tox-control-wrap--status-invalid .tox-textfield,
.tox[dir="rtl"] .tox-control-wrap--status-unknown .tox-textfield,
.tox[dir="rtl"] .tox-control-wrap--status-valid .tox-textfield {
  padding-left: 32px;
}
.tox[dir="rtl"] .tox-control-wrap__status-icon-wrap {
  left: 4px;
}
.tox .tox-autocompleter {
  max-width: 25em;
}
.tox .tox-autocompleter .tox-menu {
  max-width: 25em;
}
.tox .tox-autocompleter .tox-autocompleter-highlight {
  font-weight: 700;
}
.tox .tox-color-input {
  display: flex;
  position: relative;
  z-index: 1;
}
.tox .tox-color-input .tox-textfield {
  z-index: -1;
}
.tox .tox-color-input span {
  border-color: rgba(34, 47, 62, 0.2);
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  height: 24px;
  position: absolute;
  top: 6px;
  width: 24px;
}
.tox .tox-color-input span:focus:not([aria-disabled="true"]),
.tox .tox-color-input span:hover:not([aria-disabled="true"]) {
  border-color: #207ab7;
  cursor: pointer;
}
.tox .tox-color-input span::before {
  background-image:
    linear-gradient(45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%),
    linear-gradient(-45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%),
    linear-gradient(-45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%);
  background-position:
    0 0,
    0 6px,
    6px -6px,
    -6px 0;
  background-size: 12px 12px;
  border: 1px solid #fff;
  border-radius: 3px;
  box-sizing: border-box;
  content: "";
  height: 24px;
  left: -1px;
  position: absolute;
  top: -1px;
  width: 24px;
  z-index: -1;
}
.tox .tox-color-input span[aria-disabled="true"] {
  cursor: not-allowed;
}
.tox:not([dir="rtl"]) .tox-color-input .tox-textfield {
  padding-left: 36px;
}
.tox:not([dir="rtl"]) .tox-color-input span {
  left: 6px;
}
.tox[dir="rtl"] .tox-color-input .tox-textfield {
  padding-right: 36px;
}
.tox[dir="rtl"] .tox-color-input span {
  right: 6px;
}
.tox .tox-label,
.tox .tox-toolbar-label {
  color: rgba(34, 47, 62, 0.7);
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  padding: 0 8px 0 0;
  text-transform: none;
  white-space: nowrap;
}
.tox .tox-toolbar-label {
  padding: 0 8px;
}
.tox[dir="rtl"] .tox-label {
  padding: 0 0 0 8px;
}
.tox .tox-form {
  display: flex;
  flex: 1;
  flex-direction: column;
  -ms-flex-preferred-size: auto;
}
.tox .tox-form__group {
  box-sizing: border-box;
  margin-bottom: 4px;
}
.tox .tox-form-group--maximize {
  flex: 1;
}
.tox .tox-form__group--error {
  color: #c00;
}
.tox .tox-form__group--collection {
  display: flex;
}
.tox .tox-form__grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.tox .tox-form__grid--2col > .tox-form__group {
  width: calc(50% - (8px / 2));
}
.tox .tox-form__grid--3col > .tox-form__group {
  width: calc(100% / 3 - (8px / 2));
}
.tox .tox-form__grid--4col > .tox-form__group {
  width: calc(25% - (8px / 2));
}
.tox .tox-form__controls-h-stack {
  align-items: center;
  display: flex;
}
.tox .tox-form__group--inline {
  align-items: center;
  display: flex;
}
.tox .tox-form__group--stretched {
  display: flex;
  flex: 1;
  flex-direction: column;
  -ms-flex-preferred-size: auto;
}
.tox .tox-form__group--stretched .tox-textarea {
  flex: 1;
  -ms-flex-preferred-size: auto;
}
.tox .tox-form__group--stretched .tox-navobj {
  display: flex;
  flex: 1;
  -ms-flex-preferred-size: auto;
}
.tox .tox-form__group--stretched .tox-navobj :nth-child(2) {
  flex: 1;
  -ms-flex-preferred-size: auto;
  height: 100%;
}
.tox:not([dir="rtl"]) .tox-form__controls-h-stack > :not(:first-child) {
  margin-left: 4px;
}
.tox[dir="rtl"] .tox-form__controls-h-stack > :not(:first-child) {
  margin-right: 4px;
}
.tox .tox-lock.tox-locked .tox-lock-icon__unlock,
.tox .tox-lock:not(.tox-locked) .tox-lock-icon__lock {
  display: none;
}
.tox .tox-listboxfield .tox-listbox--select,
.tox .tox-textarea,
.tox .tox-textfield,
.tox .tox-toolbar-textfield {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #fff;
  border-color: #ccc;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #222f3e;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  min-height: 34px;
  outline: 0;
  padding: 5px 4.75px;
  resize: none;
  width: 100%;
}
.tox .tox-textarea[disabled],
.tox .tox-textfield[disabled] {
  background-color: #f2f2f2;
  color: rgba(34, 47, 62, 0.85);
  cursor: not-allowed;
}
.tox .tox-listboxfield .tox-listbox--select:focus,
.tox .tox-textarea:focus,
.tox .tox-textfield:focus {
  background-color: #fff;
  border-color: #207ab7;
  box-shadow: none;
  outline: 0;
}
.tox .tox-toolbar-textfield {
  border-width: 0;
  margin-bottom: 3px;
  margin-top: 2px;
  max-width: 250px;
}
.tox .tox-naked-btn {
  background-color: transparent;
  border: 0;
  border-color: transparent;
  box-shadow: unset;
  color: #207ab7;
  cursor: pointer;
  display: block;
  margin: 0;
  padding: 0;
}
.tox .tox-naked-btn svg {
  display: block;
  fill: #222f3e;
}
.tox:not([dir="rtl"]) .tox-toolbar-textfield + * {
  margin-left: 4px;
}
.tox[dir="rtl"] .tox-toolbar-textfield + * {
  margin-right: 4px;
}
.tox .tox-listboxfield {
  cursor: pointer;
  position: relative;
}
.tox .tox-listboxfield .tox-listbox--select[disabled] {
  background-color: #f2f2f2;
  color: rgba(34, 47, 62, 0.85);
  cursor: not-allowed;
}
.tox .tox-listbox__select-label {
  cursor: default;
  flex: 1;
  margin: 0 4px;
}
.tox .tox-listbox__select-chevron {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
}
.tox .tox-listbox__select-chevron svg {
  fill: #222f3e;
}
.tox .tox-listboxfield .tox-listbox--select {
  align-items: center;
  display: flex;
}
.tox:not([dir="rtl"]) .tox-listboxfield svg {
  right: 8px;
}
.tox[dir="rtl"] .tox-listboxfield svg {
  left: 8px;
}
.tox .tox-selectfield {
  cursor: pointer;
  position: relative;
}
.tox .tox-selectfield select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #fff;
  border-color: #ccc;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #222f3e;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  min-height: 34px;
  outline: 0;
  padding: 5px 4.75px;
  resize: none;
  width: 100%;
}
.tox .tox-selectfield select[disabled] {
  background-color: #f2f2f2;
  color: rgba(34, 47, 62, 0.85);
  cursor: not-allowed;
}
.tox .tox-selectfield select::-ms-expand {
  display: none;
}
.tox .tox-selectfield select:focus {
  background-color: #fff;
  border-color: #207ab7;
  box-shadow: none;
  outline: 0;
}
.tox .tox-selectfield svg {
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.tox:not([dir="rtl"]) .tox-selectfield select[size="0"],
.tox:not([dir="rtl"]) .tox-selectfield select[size="1"] {
  padding-right: 24px;
}
.tox:not([dir="rtl"]) .tox-selectfield svg {
  right: 8px;
}
.tox[dir="rtl"] .tox-selectfield select[size="0"],
.tox[dir="rtl"] .tox-selectfield select[size="1"] {
  padding-left: 24px;
}
.tox[dir="rtl"] .tox-selectfield svg {
  left: 8px;
}
.tox .tox-textarea {
  -webkit-appearance: textarea;
  -moz-appearance: textarea;
  appearance: textarea;
  white-space: pre-wrap;
}
.tox-fullscreen {
  border: 0;
  height: 100%;
  margin: 0;
  overflow: hidden;
  -ms-scroll-chaining: none;
  overscroll-behavior: none;
  padding: 0;
  touch-action: pinch-zoom;
  width: 100%;
}
.tox.tox-tinymce.tox-fullscreen .tox-statusbar__resize-handle {
  display: none;
}
.tox-shadowhost.tox-fullscreen,
.tox.tox-tinymce.tox-fullscreen {
  left: 0;
  position: fixed;
  top: 0;
  z-index: 1200;
}
.tox.tox-tinymce.tox-fullscreen {
  background-color: transparent;
}
.tox-fullscreen .tox.tox-tinymce-aux,
.tox-fullscreen ~ .tox.tox-tinymce-aux {
  z-index: 1201;
}
.tox .tox-help__more-link {
  list-style: none;
  margin-top: 1em;
}
.tox .tox-image-tools {
  width: 100%;
}
.tox .tox-image-tools__toolbar {
  align-items: center;
  display: flex;
  justify-content: center;
}
.tox .tox-image-tools__image {
  background-color: #666;
  height: 380px;
  overflow: auto;
  position: relative;
  width: 100%;
}
.tox .tox-image-tools__image,
.tox .tox-image-tools__image + .tox-image-tools__toolbar {
  margin-top: 8px;
}
.tox .tox-image-tools__image-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.tox .tox-image-tools__toolbar > .tox-spacer {
  flex: 1;
  -ms-flex-preferred-size: auto;
}
.tox .tox-croprect-block {
  background: #000;
  opacity: 0.5;
  position: absolute;
  zoom: 1;
}
.tox .tox-croprect-handle {
  border: 2px solid #fff;
  height: 20px;
  left: 0;
  position: absolute;
  top: 0;
  width: 20px;
}
.tox .tox-croprect-handle-move {
  border: 0;
  cursor: move;
  position: absolute;
}
.tox .tox-croprect-handle-nw {
  border-width: 2px 0 0 2px;
  cursor: nw-resize;
  left: 100px;
  margin: -2px 0 0 -2px;
  top: 100px;
}
.tox .tox-croprect-handle-ne {
  border-width: 2px 2px 0 0;
  cursor: ne-resize;
  left: 200px;
  margin: -2px 0 0 -20px;
  top: 100px;
}
.tox .tox-croprect-handle-sw {
  border-width: 0 0 2px 2px;
  cursor: sw-resize;
  left: 100px;
  margin: -20px 2px 0 -2px;
  top: 200px;
}
.tox .tox-croprect-handle-se {
  border-width: 0 2px 2px 0;
  cursor: se-resize;
  left: 200px;
  margin: -20px 0 0 -20px;
  top: 200px;
}
.tox:not([dir="rtl"])
  .tox-image-tools__toolbar
  > .tox-slider:not(:first-of-type) {
  margin-left: 8px;
}
.tox:not([dir="rtl"]) .tox-image-tools__toolbar > .tox-button + .tox-slider {
  margin-left: 32px;
}
.tox:not([dir="rtl"]) .tox-image-tools__toolbar > .tox-slider + .tox-button {
  margin-left: 32px;
}
.tox[dir="rtl"] .tox-image-tools__toolbar > .tox-slider:not(:first-of-type) {
  margin-right: 8px;
}
.tox[dir="rtl"] .tox-image-tools__toolbar > .tox-button + .tox-slider {
  margin-right: 32px;
}
.tox[dir="rtl"] .tox-image-tools__toolbar > .tox-slider + .tox-button {
  margin-right: 32px;
}
.tox .tox-insert-table-picker {
  display: flex;
  flex-wrap: wrap;
  width: 170px;
}
.tox .tox-insert-table-picker > div {
  border-color: #ccc;
  border-style: solid;
  border-width: 0 1px 1px 0;
  box-sizing: border-box;
  height: 17px;
  width: 17px;
}
.tox .tox-collection--list .tox-collection__group .tox-insert-table-picker {
  margin: -4px 0;
}
.tox .tox-insert-table-picker .tox-insert-table-picker__selected {
  background-color: rgba(32, 122, 183, 0.5);
  border-color: rgba(32, 122, 183, 0.5);
}
.tox .tox-insert-table-picker__label {
  color: rgba(34, 47, 62, 0.7);
  display: block;
  font-size: 14px;
  padding: 4px;
  text-align: center;
  width: 100%;
}
.tox:not([dir="rtl"]) .tox-insert-table-picker > div:nth-child(10n) {
  border-right: 0;
}
.tox[dir="rtl"] .tox-insert-table-picker > div:nth-child(10n + 1) {
  border-right: 0;
}
.tox .tox-menu {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);
  display: inline-block;
  overflow: hidden;
  vertical-align: top;
  z-index: 1150;
}
.tox .tox-menu.tox-collection.tox-collection--list {
  padding: 0;
}
.tox .tox-menu.tox-collection.tox-collection--toolbar {
  padding: 4px;
}
.tox .tox-menu.tox-collection.tox-collection--grid {
  padding: 4px;
}
.tox .tox-menu__label blockquote,
.tox .tox-menu__label code,
.tox .tox-menu__label h1,
.tox .tox-menu__label h2,
.tox .tox-menu__label h3,
.tox .tox-menu__label h4,
.tox .tox-menu__label h5,
.tox .tox-menu__label h6,
.tox .tox-menu__label p {
  margin: 0;
}
.tox .tox-menubar {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    left 0 top 0 #fff;
  background-color: #fff;
  display: flex;
  flex: 0 0 auto;
  flex-shrink: 0;
  flex-wrap: wrap;
  padding: 0 4px 0 4px;
}
.tox.tox-tinymce:not(.tox-tinymce-inline)
  .tox-editor-header:not(:first-child)
  .tox-menubar {
  border-top: 1px solid #ccc;
}
.tox .tox-mbtn {
  align-items: center;
  background: 0 0;
  border: 0;
  border-radius: 3px;
  box-shadow: none;
  color: #222f3e;
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: 34px;
  justify-content: center;
  margin: 2px 0 3px 0;
  outline: 0;
  overflow: hidden;
  padding: 0 4px;
  text-transform: none;
  width: auto;
}
.tox .tox-mbtn[disabled] {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-mbtn:focus:not(:disabled) {
  background: #dee0e2;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-mbtn--active {
  background: #c8cbcf;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
  background: #dee0e2;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-mbtn__select-label {
  cursor: default;
  font-weight: 400;
  margin: 0 4px;
}
.tox .tox-mbtn[disabled] .tox-mbtn__select-label {
  cursor: not-allowed;
}
.tox .tox-mbtn__select-chevron {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
  display: none;
}
.tox .tox-notification {
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  display: -ms-grid;
  display: grid;
  font-size: 14px;
  font-weight: 400;
  -ms-grid-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);
  grid-template-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);
  margin-top: 4px;
  opacity: 0;
  padding: 4px;
  transition:
    transform 0.1s ease-in,
    opacity 150ms ease-in;
}
.tox .tox-notification p {
  font-size: 14px;
  font-weight: 400;
}
.tox .tox-notification a {
  cursor: pointer;
  text-decoration: underline;
}
.tox .tox-notification--in {
  opacity: 1;
}
.tox .tox-notification--success {
  background-color: #e4eeda;
  border-color: #d7e6c8;
  color: #222f3e;
}
.tox .tox-notification--success p {
  color: #222f3e;
}
.tox .tox-notification--success a {
  color: #547831;
}
.tox .tox-notification--success svg {
  fill: #222f3e;
}
.tox .tox-notification--error {
  background-color: #f8dede;
  border-color: #f2bfbf;
  color: #222f3e;
}
.tox .tox-notification--error p {
  color: #222f3e;
}
.tox .tox-notification--error a {
  color: #c00;
}
.tox .tox-notification--error svg {
  fill: #222f3e;
}
.tox .tox-notification--warn,
.tox .tox-notification--warning {
  background-color: #fffaea;
  border-color: #ffe89d;
  color: #222f3e;
}
.tox .tox-notification--warn p,
.tox .tox-notification--warning p {
  color: #222f3e;
}
.tox .tox-notification--warn a,
.tox .tox-notification--warning a {
  color: #222f3e;
}
.tox .tox-notification--warn svg,
.tox .tox-notification--warning svg {
  fill: #222f3e;
}
.tox .tox-notification--info {
  background-color: #d9edf7;
  border-color: #779ecb;
  color: #222f3e;
}
.tox .tox-notification--info p {
  color: #222f3e;
}
.tox .tox-notification--info a {
  color: #222f3e;
}
.tox .tox-notification--info svg {
  fill: #222f3e;
}
.tox .tox-notification__body {
  -ms-grid-row-align: center;
  align-self: center;
  color: #222f3e;
  font-size: 14px;
  -ms-grid-column-span: 1;
  grid-column-end: 3;
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  -ms-grid-row: 1;
  grid-row-start: 1;
  text-align: center;
  white-space: normal;
  word-break: break-all;
  word-break: break-word;
}
.tox .tox-notification__body > * {
  margin: 0;
}
.tox .tox-notification__body > * + * {
  margin-top: 1rem;
}
.tox .tox-notification__icon {
  -ms-grid-row-align: center;
  align-self: center;
  -ms-grid-column-span: 1;
  grid-column-end: 2;
  -ms-grid-column: 1;
  grid-column-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  -ms-grid-row: 1;
  grid-row-start: 1;
  -ms-grid-column-align: end;
  justify-self: end;
}
.tox .tox-notification__icon svg {
  display: block;
}
.tox .tox-notification__dismiss {
  -ms-grid-row-align: start;
  align-self: start;
  -ms-grid-column-span: 1;
  grid-column-end: 4;
  -ms-grid-column: 3;
  grid-column-start: 3;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  -ms-grid-row: 1;
  grid-row-start: 1;
  -ms-grid-column-align: end;
  justify-self: end;
}
.tox .tox-notification .tox-progress-bar {
  -ms-grid-column-span: 3;
  grid-column-end: 4;
  -ms-grid-column: 1;
  grid-column-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 3;
  -ms-grid-row: 2;
  grid-row-start: 2;
  -ms-grid-column-align: center;
  justify-self: center;
}
.tox .tox-pop {
  display: inline-block;
  position: relative;
}
.tox .tox-pop--resizing {
  transition: width 0.1s ease;
}
.tox .tox-pop--resizing .tox-toolbar,
.tox .tox-pop--resizing .tox-toolbar__group {
  flex-wrap: nowrap;
}
.tox .tox-pop--transition {
  transition: 0.15s ease;
  transition-property: left, right, top, bottom;
}
.tox .tox-pop--transition::after,
.tox .tox-pop--transition::before {
  transition:
    all 0.15s,
    visibility 0s,
    opacity 75ms ease 75ms;
}
.tox .tox-pop__dialog {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  min-width: 0;
  overflow: hidden;
}
.tox .tox-pop__dialog > :not(.tox-toolbar) {
  margin: 4px 4px 4px 8px;
}
.tox .tox-pop__dialog .tox-toolbar {
  background-color: transparent;
  margin-bottom: -1px;
}
.tox .tox-pop::after,
.tox .tox-pop::before {
  border-style: solid;
  content: "";
  display: block;
  height: 0;
  opacity: 1;
  position: absolute;
  width: 0;
}
.tox .tox-pop.tox-pop--inset::after,
.tox .tox-pop.tox-pop--inset::before {
  opacity: 0;
  transition:
    all 0s 0.15s,
    visibility 0s,
    opacity 75ms ease;
}
.tox .tox-pop.tox-pop--bottom::after,
.tox .tox-pop.tox-pop--bottom::before {
  left: 50%;
  top: 100%;
}
.tox .tox-pop.tox-pop--bottom::after {
  border-color: #fff transparent transparent transparent;
  border-width: 8px;
  margin-left: -8px;
  margin-top: -1px;
}
.tox .tox-pop.tox-pop--bottom::before {
  border-color: #ccc transparent transparent transparent;
  border-width: 9px;
  margin-left: -9px;
}
.tox .tox-pop.tox-pop--top::after,
.tox .tox-pop.tox-pop--top::before {
  left: 50%;
  top: 0;
  transform: translateY(-100%);
}
.tox .tox-pop.tox-pop--top::after {
  border-color: transparent transparent #fff transparent;
  border-width: 8px;
  margin-left: -8px;
  margin-top: 1px;
}
.tox .tox-pop.tox-pop--top::before {
  border-color: transparent transparent #ccc transparent;
  border-width: 9px;
  margin-left: -9px;
}
.tox .tox-pop.tox-pop--left::after,
.tox .tox-pop.tox-pop--left::before {
  left: 0;
  top: calc(50% - 1px);
  transform: translateY(-50%);
}
.tox .tox-pop.tox-pop--left::after {
  border-color: transparent #fff transparent transparent;
  border-width: 8px;
  margin-left: -15px;
}
.tox .tox-pop.tox-pop--left::before {
  border-color: transparent #ccc transparent transparent;
  border-width: 10px;
  margin-left: -19px;
}
.tox .tox-pop.tox-pop--right::after,
.tox .tox-pop.tox-pop--right::before {
  left: 100%;
  top: calc(50% + 1px);
  transform: translateY(-50%);
}
.tox .tox-pop.tox-pop--right::after {
  border-color: transparent transparent transparent #fff;
  border-width: 8px;
  margin-left: -1px;
}
.tox .tox-pop.tox-pop--right::before {
  border-color: transparent transparent transparent #ccc;
  border-width: 10px;
  margin-left: -1px;
}
.tox .tox-pop.tox-pop--align-left::after,
.tox .tox-pop.tox-pop--align-left::before {
  left: 20px;
}
.tox .tox-pop.tox-pop--align-right::after,
.tox .tox-pop.tox-pop--align-right::before {
  left: calc(100% - 20px);
}
.tox .tox-sidebar-wrap {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  -ms-flex-preferred-size: 0;
  min-height: 0;
}
.tox .tox-sidebar {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.tox .tox-sidebar__slider {
  display: flex;
  overflow: hidden;
}
.tox .tox-sidebar__pane-container {
  display: flex;
}
.tox .tox-sidebar__pane {
  display: flex;
}
.tox .tox-sidebar--sliding-closed {
  opacity: 0;
}
.tox .tox-sidebar--sliding-open {
  opacity: 1;
}
.tox .tox-sidebar--sliding-growing,
.tox .tox-sidebar--sliding-shrinking {
  transition:
    width 0.5s ease,
    opacity 0.5s ease;
}
.tox .tox-selector {
  background-color: #4099ff;
  border-color: #4099ff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  display: inline-block;
  height: 10px;
  position: absolute;
  width: 10px;
}
.tox.tox-platform-touch .tox-selector {
  height: 12px;
  width: 12px;
}
.tox .tox-slider {
  align-items: center;
  display: flex;
  flex: 1;
  -ms-flex-preferred-size: auto;
  height: 24px;
  justify-content: center;
  position: relative;
}
.tox .tox-slider__rail {
  background-color: transparent;
  border: 1px solid #ccc;
  border-radius: 3px;
  height: 10px;
  min-width: 120px;
  width: 100%;
}
.tox .tox-slider__handle {
  background-color: #207ab7;
  border: 2px solid #185d8c;
  border-radius: 3px;
  box-shadow: none;
  height: 24px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 14px;
}
.tox .tox-source-code {
  overflow: auto;
}
.tox .tox-spinner {
  display: flex;
}
.tox .tox-spinner > div {
  animation: tam-bouncing-dots 1.5s ease-in-out 0s infinite both;
  background-color: rgba(34, 47, 62, 0.7);
  border-radius: 100%;
  height: 8px;
  width: 8px;
}
.tox .tox-spinner > div:nth-child(1) {
  animation-delay: -0.32s;
}
.tox .tox-spinner > div:nth-child(2) {
  animation-delay: -0.16s;
}
@keyframes tam-bouncing-dots {
  0%,
  100%,
  80% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.tox:not([dir="rtl"]) .tox-spinner > div:not(:first-child) {
  margin-left: 4px;
}
.tox[dir="rtl"] .tox-spinner > div:not(:first-child) {
  margin-right: 4px;
}
.tox .tox-statusbar {
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #ccc;
  color: rgba(34, 47, 62, 0.7);
  display: flex;
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 400;
  height: 18px;
  overflow: hidden;
  padding: 0 8px;
  position: relative;
  text-transform: uppercase;
}
.tox .tox-statusbar__text-container {
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  overflow: hidden;
}
.tox .tox-statusbar__path {
  display: flex;
  flex: 1 1 auto;
  margin-right: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tox .tox-statusbar__path > * {
  display: inline;
  white-space: nowrap;
}
.tox .tox-statusbar__wordcount {
  flex: 0 0 auto;
  margin-left: 1ch;
}
.tox .tox-statusbar a,
.tox .tox-statusbar__path-item,
.tox .tox-statusbar__wordcount {
  color: rgba(34, 47, 62, 0.7);
  text-decoration: none;
}
.tox .tox-statusbar a:focus:not(:disabled):not([aria-disabled="true"]),
.tox .tox-statusbar a:hover:not(:disabled):not([aria-disabled="true"]),
.tox .tox-statusbar__path-item:focus:not(:disabled):not([aria-disabled="true"]),
.tox .tox-statusbar__path-item:hover:not(:disabled):not([aria-disabled="true"]),
.tox .tox-statusbar__wordcount:focus:not(:disabled):not([aria-disabled="true"]),
.tox
  .tox-statusbar__wordcount:hover:not(:disabled):not([aria-disabled="true"]) {
  cursor: pointer;
  text-decoration: underline;
}
.tox .tox-statusbar__resize-handle {
  align-items: flex-end;
  align-self: stretch;
  cursor: nwse-resize;
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: -8px;
  padding-left: 1ch;
}
.tox .tox-statusbar__resize-handle svg {
  display: block;
  fill: rgba(34, 47, 62, 0.7);
}
.tox .tox-statusbar__resize-handle:focus svg {
  background-color: #dee0e2;
  border-radius: 1px;
  box-shadow: 0 0 0 2px #dee0e2;
}
.tox:not([dir="rtl"]) .tox-statusbar__path > * {
  margin-right: 4px;
}
.tox:not([dir="rtl"]) .tox-statusbar__branding {
  margin-left: 1ch;
}
.tox[dir="rtl"] .tox-statusbar {
  flex-direction: row-reverse;
}
.tox[dir="rtl"] .tox-statusbar__path > * {
  margin-left: 4px;
}
.tox .tox-throbber {
  z-index: 1299;
}
.tox .tox-throbber__busy-spinner {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.tox .tox-tbtn {
  align-items: center;
  background: 0 0;
  border: 0;
  border-radius: 3px;
  box-shadow: none;
  color: #222f3e;
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: 34px;
  justify-content: center;
  margin: 2px 0 3px 0;
  outline: 0;
  overflow: hidden;
  padding: 0;
  text-transform: none;
  width: 34px;
}
.tox .tox-tbtn svg {
  display: block;
  fill: #222f3e;
}
.tox .tox-tbtn.tox-tbtn-more {
  padding-left: 5px;
  padding-right: 5px;
  width: inherit;
}
.tox .tox-tbtn:focus {
  background: #dee0e2;
  border: 0;
  box-shadow: none;
}
.tox .tox-tbtn:hover {
  background: #dee0e2;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tbtn:hover svg {
  fill: #222f3e;
}
.tox .tox-tbtn:active {
  background: #c8cbcf;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tbtn:active svg {
  fill: #222f3e;
}
.tox .tox-tbtn--disabled,
.tox .tox-tbtn--disabled:hover,
.tox .tox-tbtn:disabled,
.tox .tox-tbtn:disabled:hover {
  background: 0 0;
  border: 0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-tbtn--disabled svg,
.tox .tox-tbtn--disabled:hover svg,
.tox .tox-tbtn:disabled svg,
.tox .tox-tbtn:disabled:hover svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-tbtn--enabled,
.tox .tox-tbtn--enabled:hover {
  background: #c8cbcf;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tbtn--enabled:hover > *,
.tox .tox-tbtn--enabled > * {
  transform: none;
}
.tox .tox-tbtn--enabled svg,
.tox .tox-tbtn--enabled:hover svg {
  fill: #222f3e;
}
.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) {
  color: #222f3e;
}
.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) svg {
  fill: #222f3e;
}
.tox .tox-tbtn:active > * {
  transform: none;
}
.tox .tox-tbtn--md {
  height: 51px;
  width: 51px;
}
.tox .tox-tbtn--lg {
  flex-direction: column;
  height: 68px;
  width: 68px;
}
.tox .tox-tbtn--return {
  -ms-grid-row-align: stretch;
  align-self: stretch;
  height: unset;
  width: 16px;
}
.tox .tox-tbtn--labeled {
  padding: 0 4px;
  width: unset;
}
.tox .tox-tbtn__vlabel {
  display: block;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: -0.025em;
  margin-bottom: 4px;
  white-space: nowrap;
}
.tox .tox-tbtn--select {
  margin: 2px 0 3px 0;
  padding: 0 4px;
  width: auto;
}
.tox .tox-tbtn__select-label {
  cursor: default;
  font-weight: 400;
  margin: 0 4px;
}
.tox .tox-tbtn__select-chevron {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
}
.tox .tox-tbtn__select-chevron svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-tbtn--bespoke .tox-tbtn__select-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 7em;
}
.tox .tox-split-button {
  border: 0;
  border-radius: 3px;
  box-sizing: border-box;
  display: flex;
  margin: 2px 0 3px 0;
  overflow: hidden;
}
.tox .tox-split-button:hover {
  box-shadow: 0 0 0 1px #dee0e2 inset;
}
.tox .tox-split-button:focus {
  background: #dee0e2;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-split-button > * {
  border-radius: 0;
}
.tox .tox-split-button__chevron {
  width: 16px;
}
.tox .tox-split-button__chevron svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-split-button .tox-tbtn {
  margin: 0;
}
.tox.tox-platform-touch .tox-split-button .tox-tbtn:first-child {
  width: 30px;
}
.tox.tox-platform-touch .tox-split-button__chevron {
  width: 20px;
}
.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:focus,
.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:hover,
.tox .tox-split-button.tox-tbtn--disabled:focus,
.tox .tox-split-button.tox-tbtn--disabled:hover {
  background: 0 0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
}
.tox .tox-toolbar-overlord {
  background-color: #fff;
}
.tox .tox-toolbar,
.tox .tox-toolbar__overflow,
.tox .tox-toolbar__primary {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    left 0 top 0 #fff;
  background-color: #fff;
  display: flex;
  flex: 0 0 auto;
  flex-shrink: 0;
  flex-wrap: wrap;
  padding: 0 0;
}
.tox .tox-toolbar__overflow.tox-toolbar__overflow--closed {
  height: 0;
  opacity: 0;
  padding-bottom: 0;
  padding-top: 0;
  visibility: hidden;
}
.tox .tox-toolbar__overflow--growing {
  transition:
    height 0.3s ease,
    opacity 0.2s linear 0.1s;
}
.tox .tox-toolbar__overflow--shrinking {
  transition:
    opacity 0.3s ease,
    height 0.2s linear 0.1s,
    visibility 0s linear 0.3s;
}
.tox .tox-menubar + .tox-toolbar,
.tox .tox-menubar + .tox-toolbar-overlord .tox-toolbar__primary {
  border-top: 1px solid #ccc;
  margin-top: -1px;
}
.tox .tox-toolbar--scrolling {
  flex-wrap: nowrap;
  overflow-x: auto;
}
.tox .tox-pop .tox-toolbar {
  border-width: 0;
}
.tox .tox-toolbar--no-divider {
  background-image: none;
}
.tox-tinymce:not(.tox-tinymce-inline)
  .tox-editor-header:not(:first-child)
  .tox-toolbar-overlord:first-child
  .tox-toolbar__primary,
.tox-tinymce:not(.tox-tinymce-inline)
  .tox-editor-header:not(:first-child)
  .tox-toolbar:first-child {
  border-top: 1px solid #ccc;
}
.tox.tox-tinymce-aux .tox-toolbar__overflow {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}
.tox .tox-toolbar__group {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0 0;
  padding: 0 4px 0 4px;
}
.tox .tox-toolbar__group--pull-right {
  margin-left: auto;
}
.tox .tox-toolbar--scrolling .tox-toolbar__group {
  flex-shrink: 0;
  flex-wrap: nowrap;
}
.tox:not([dir="rtl"]) .tox-toolbar__group:not(:last-of-type) {
  border-right: 1px solid #ccc;
}
.tox[dir="rtl"] .tox-toolbar__group:not(:last-of-type) {
  border-left: 1px solid #ccc;
}
.tox .tox-tooltip {
  display: inline-block;
  padding: 8px;
  position: relative;
}
.tox .tox-tooltip__body {
  background-color: #222f3e;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(34, 47, 62, 0.3);
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding: 4px 8px;
  text-transform: none;
}
.tox .tox-tooltip__arrow {
  position: absolute;
}
.tox .tox-tooltip--down .tox-tooltip__arrow {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #222f3e;
  bottom: 0;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}
.tox .tox-tooltip--up .tox-tooltip__arrow {
  border-bottom: 8px solid #222f3e;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
}
.tox .tox-tooltip--right .tox-tooltip__arrow {
  border-bottom: 8px solid transparent;
  border-left: 8px solid #222f3e;
  border-top: 8px solid transparent;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.tox .tox-tooltip--left .tox-tooltip__arrow {
  border-bottom: 8px solid transparent;
  border-right: 8px solid #222f3e;
  border-top: 8px solid transparent;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.tox .tox-well {
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 8px;
  width: 100%;
}
.tox .tox-well > :first-child {
  margin-top: 0;
}
.tox .tox-well > :last-child {
  margin-bottom: 0;
}
.tox .tox-well > :only-child {
  margin: 0;
}
.tox .tox-custom-editor {
  border: 1px solid #ccc;
  border-radius: 3px;
  display: flex;
  flex: 1;
  position: relative;
}
.tox .tox-dialog-loading::before {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1000;
}
.tox .tox-tab {
  cursor: pointer;
}
.tox .tox-dialog__content-js {
  display: flex;
  flex: 1;
  -ms-flex-preferred-size: auto;
}
.tox .tox-dialog__body-content .tox-collection {
  display: flex;
  flex: 1;
  -ms-flex-preferred-size: auto;
}
.tox .tox-image-tools-edit-panel {
  height: 60px;
}
.tox .tox-image-tools__sidebar {
  height: 60px;
}
`, "",{"version":3,"sources":["webpack://./lib/ReactViews/Generic/editor.skin.min.css"],"names":[],"mappings":"AAAA;;;;;CAKC;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ;;2CAEyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB;;2CAEyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;;2CAEyC;EACzC,aAAa;AACf;AACA;;EAEE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,yCAAyC;EACzC,qCAAqC;EACrC,cAAc;AAChB;AACA;;;;;EAKE,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,wCAAwC;EACxC,oCAAoC;EACpC,cAAc;AAChB;AACA;;;;;EAKE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;AACA;;;;;EAKE,kCAAkC;AACpC;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,yCAAyC;EACzC,qCAAqC;EACrC,cAAc;AAChB;AACA;;;;;EAKE,qCAAqC;AACvC;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;;;;;EAME,aAAa;AACf;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;;EAGE,wBAAwB;AAC1B;AACA;;;;EAIE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;;;;EAIE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB;;2CAEyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB;;2CAEyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;;;;;EAKE,2BAA2B;AAC7B;AACA;;;;;EAKE,2BAA2B;AAC7B;AACA;;;;;EAKE,2BAA2B;AAC7B;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;EACP,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;;EAKE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;;EAEE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;;EAEE,oBAAoB;AACtB;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,2BAA2B;AAC7B;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE;;;;;;;;;;;;;;;GAeC;EACD,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ;;oBAEkB;EAClB,WAAW;AACb;AACA;;EAEE,oDAAoD;EACpD,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yDAAyD;EACzD,SAAS;EACT,WAAW;EACX,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,eAAe;EACf,QAAQ;EACR,MAAM;EACN,aAAa;AACf;AACA;EACE,2CAA2C;EAC3C,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB;;uCAEqC;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;;2CAEyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,aAAa;EACb,OAAO;EACP,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;IACnB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,OAAO;EACP,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE;;qBAEmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;;;IAGE,gBAAgB;EAClB;AACF;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;;;IAGE,iBAAiB;EACnB;AACF;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,OAAO;EACP,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,OAAO;EACP,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,8CAA8C;AAChD;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE;;sBAEoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,kBAAkB;AACpB;AACA;;;;;;;;;EASE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE;;;;qEAImE;EACnE;;;;UAIQ;EACR,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,OAAO;AACT;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,OAAO;EACP,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd;;2CAEyC;EACzC,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;;;EAGE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,OAAO;EACP,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd;;2CAEyC;EACzC,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;EACV,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;;EAEE,OAAO;EACP,eAAe;EACf,MAAM;EACN,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;EACE,mDAAmH;AACrH;AACA;EACE,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,UAAU;AACZ;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,6CAA6C;EAC7C,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;;;;;;;;EASE,SAAS;AACX;AACA;EACE;qBACmB;EACnB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;;;EAGE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0DAA0D;EAC1D,+DAA+D;EAC/D,eAAe;EACf,UAAU;EACV,YAAY;EACZ;;yBAEuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;;EAEE;;;0BAGwB;AAC1B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ;AACV;AACA;;EAEE,UAAU;EACV;;;qBAGmB;AACrB;AACA;;EAEE,SAAS;EACT,SAAS;AACX;AACA;EACE,sDAAsD;EACtD,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sDAAsD;EACtD,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;EAEE,SAAS;EACT,MAAM;EACN,4BAA4B;AAC9B;AACA;EACE,sDAAsD;EACtD,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,sDAAsD;EACtD,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;EAEE,OAAO;EACP,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,sDAAsD;EACtD,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,UAAU;EACV,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,sDAAsD;EACtD,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE;;qBAEmB;AACrB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,6BAA6B;EAC7B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,4CAA4C;EAC5C,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,8DAA8D;EAC9D,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;;;IAGE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;EAGE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;;;;;;;EAOE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;;;EAIE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;;;;EAIE,2BAA2B;AAC7B;AACA;;EAEE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;;;EAGE;qBACmB;EACnB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;;4BAE0B;AAC5B;AACA;EACE;;;6BAG2B;AAC7B;AACA;;EAEE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;;;;;;;EAOE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,iCAAiC;EACjC,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":["/**\n* Copyright (c) Tiny Technologies, Inc. All rights reserved.\n* Licensed under the LGPL or a commercial license.\n* For LGPL see License.txt in the project root for license information.\n* For commercial licenses see https://www.tiny.cloud/\n*/\n.tox {\n  box-shadow: none;\n  box-sizing: content-box;\n  color: #222f3e;\n  cursor: auto;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  -webkit-tap-highlight-color: transparent;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  vertical-align: initial;\n  white-space: normal;\n}\n.tox :not(svg):not(rect) {\n  box-sizing: inherit;\n  color: inherit;\n  cursor: inherit;\n  direction: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  -webkit-tap-highlight-color: inherit;\n  text-align: inherit;\n  text-decoration: inherit;\n  text-shadow: inherit;\n  text-transform: inherit;\n  vertical-align: inherit;\n  white-space: inherit;\n}\n.tox :not(svg):not(rect) {\n  background: 0 0;\n  border: 0;\n  box-shadow: none;\n  float: none;\n  height: auto;\n  margin: 0;\n  max-width: none;\n  outline: 0;\n  padding: 0;\n  position: static;\n  width: auto;\n}\n.tox:not([dir=\"rtl\"]) {\n  direction: ltr;\n  text-align: left;\n}\n.tox[dir=\"rtl\"] {\n  direction: rtl;\n  text-align: right;\n}\n.tox-tinymce {\n  border: 0 solid #ccc;\n  border-radius: 0;\n  box-shadow: none;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", sans-serif;\n  overflow: hidden;\n  position: relative;\n  visibility: inherit !important;\n}\n.tox-tinymce-inline {\n  border: none;\n  box-shadow: none;\n}\n.tox-tinymce-inline .tox-editor-header {\n  background-color: transparent;\n  border: 0 solid #ccc;\n  border-radius: 0;\n  box-shadow: none;\n}\n.tox-tinymce-aux {\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", sans-serif;\n  z-index: 1300;\n}\n.tox-tinymce :focus,\n.tox-tinymce-aux :focus {\n  outline: 0;\n}\nbutton::-moz-focus-inner {\n  border: 0;\n}\n.tox[dir=\"rtl\"] .tox-icon--flip svg {\n  transform: rotateY(180deg);\n}\n.tox .accessibility-issue__header {\n  align-items: center;\n  display: flex;\n  margin-bottom: 4px;\n}\n.tox .accessibility-issue__description {\n  align-items: stretch;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  display: flex;\n  justify-content: space-between;\n}\n.tox .accessibility-issue__description > div {\n  padding-bottom: 4px;\n}\n.tox .accessibility-issue__description > div > div {\n  align-items: center;\n  display: flex;\n  margin-bottom: 4px;\n}\n.tox .accessibility-issue__description > :last-child:not(:only-child) {\n  border-color: #ccc;\n  border-style: solid;\n}\n.tox .accessibility-issue__repair {\n  margin-top: 16px;\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--info\n  .accessibility-issue__description {\n  background-color: rgba(32, 122, 183, 0.1);\n  border-color: rgba(32, 122, 183, 0.4);\n  color: #222f3e;\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--info\n  .accessibility-issue__description\n  > :last-child {\n  border-color: rgba(32, 122, 183, 0.4);\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .tox-form__group h2 {\n  color: #207ab7;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .tox-icon svg {\n  fill: #207ab7;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info a .tox-icon {\n  color: #207ab7;\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--warn\n  .accessibility-issue__description {\n  background-color: rgba(255, 165, 0, 0.1);\n  border-color: rgba(255, 165, 0, 0.5);\n  color: #222f3e;\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--warn\n  .accessibility-issue__description\n  > :last-child {\n  border-color: rgba(255, 165, 0, 0.5);\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .tox-form__group h2 {\n  color: #cc8500;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .tox-icon svg {\n  fill: #cc8500;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn a .tox-icon {\n  color: #cc8500;\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--error\n  .accessibility-issue__description {\n  background-color: rgba(204, 0, 0, 0.1);\n  border-color: rgba(204, 0, 0, 0.4);\n  color: #222f3e;\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--error\n  .accessibility-issue__description\n  > :last-child {\n  border-color: rgba(204, 0, 0, 0.4);\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .tox-form__group h2 {\n  color: #c00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .tox-icon svg {\n  fill: #c00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error a .tox-icon {\n  color: #c00;\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--success\n  .accessibility-issue__description {\n  background-color: rgba(120, 171, 70, 0.1);\n  border-color: rgba(120, 171, 70, 0.4);\n  color: #222f3e;\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--success\n  .accessibility-issue__description\n  > :last-child {\n  border-color: rgba(120, 171, 70, 0.4);\n}\n.tox\n  .tox-dialog__body-content\n  .accessibility-issue--success\n  .tox-form__group\n  h2 {\n  color: #78ab46;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .tox-icon svg {\n  fill: #78ab46;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success a .tox-icon {\n  color: #78ab46;\n}\n.tox .tox-dialog__body-content .accessibility-issue__header h1,\n.tox\n  .tox-dialog__body-content\n  .tox-form__group\n  .accessibility-issue__description\n  h2 {\n  margin-top: 0;\n}\n.tox:not([dir=\"rtl\"])\n  .tox-dialog__body-content\n  .accessibility-issue__header\n  .tox-button {\n  margin-left: 4px;\n}\n.tox:not([dir=\"rtl\"])\n  .tox-dialog__body-content\n  .accessibility-issue__header\n  > :nth-last-child(2) {\n  margin-left: auto;\n}\n.tox:not([dir=\"rtl\"])\n  .tox-dialog__body-content\n  .accessibility-issue__description {\n  padding: 4px 4px 4px 8px;\n}\n.tox:not([dir=\"rtl\"])\n  .tox-dialog__body-content\n  .accessibility-issue__description\n  > :last-child {\n  border-left-width: 1px;\n  padding-left: 4px;\n}\n.tox[dir=\"rtl\"]\n  .tox-dialog__body-content\n  .accessibility-issue__header\n  .tox-button {\n  margin-right: 4px;\n}\n.tox[dir=\"rtl\"]\n  .tox-dialog__body-content\n  .accessibility-issue__header\n  > :nth-last-child(2) {\n  margin-right: auto;\n}\n.tox[dir=\"rtl\"] .tox-dialog__body-content .accessibility-issue__description {\n  padding: 4px 8px 4px 4px;\n}\n.tox[dir=\"rtl\"]\n  .tox-dialog__body-content\n  .accessibility-issue__description\n  > :last-child {\n  border-right-width: 1px;\n  padding-right: 4px;\n}\n.tox .tox-anchorbar {\n  display: flex;\n  flex: 0 0 auto;\n}\n.tox .tox-bar {\n  display: flex;\n  flex: 0 0 auto;\n}\n.tox .tox-button {\n  background-color: #207ab7;\n  background-image: none;\n  background-position: 0 0;\n  background-repeat: repeat;\n  border-color: #207ab7;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: normal;\n  line-height: 24px;\n  margin: 0;\n  outline: 0;\n  padding: 4px 16px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: none;\n  white-space: nowrap;\n}\n.tox .tox-button[disabled] {\n  background-color: #207ab7;\n  background-image: none;\n  border-color: #207ab7;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-button:focus:not(:disabled) {\n  background-color: #1c6ca1;\n  background-image: none;\n  border-color: #1c6ca1;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button:hover:not(:disabled) {\n  background-color: #1c6ca1;\n  background-image: none;\n  border-color: #1c6ca1;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button:active:not(:disabled) {\n  background-color: #185d8c;\n  background-image: none;\n  border-color: #185d8c;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button--secondary {\n  background-color: #f0f0f0;\n  background-image: none;\n  background-position: 0 0;\n  background-repeat: repeat;\n  border-color: #f0f0f0;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  color: #222f3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: normal;\n  outline: 0;\n  padding: 4px 16px;\n  text-decoration: none;\n  text-transform: none;\n}\n.tox .tox-button--secondary[disabled] {\n  background-color: #f0f0f0;\n  background-image: none;\n  border-color: #f0f0f0;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-button--secondary:focus:not(:disabled) {\n  background-color: #e3e3e3;\n  background-image: none;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--secondary:hover:not(:disabled) {\n  background-color: #e3e3e3;\n  background-image: none;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--secondary:active:not(:disabled) {\n  background-color: #d6d6d6;\n  background-image: none;\n  border-color: #d6d6d6;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--icon,\n.tox .tox-button.tox-button--icon,\n.tox .tox-button.tox-button--secondary.tox-button--icon {\n  padding: 4px;\n}\n.tox .tox-button--icon .tox-icon svg,\n.tox .tox-button.tox-button--icon .tox-icon svg,\n.tox .tox-button.tox-button--secondary.tox-button--icon .tox-icon svg {\n  display: block;\n  fill: currentColor;\n}\n.tox .tox-button-link {\n  background: 0;\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.3;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n}\n.tox .tox-button-link--sm {\n  font-size: 14px;\n}\n.tox .tox-button--naked {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: unset;\n  color: #222f3e;\n}\n.tox .tox-button--naked[disabled] {\n  background-color: #f0f0f0;\n  border-color: #f0f0f0;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-button--naked:hover:not(:disabled) {\n  background-color: #e3e3e3;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--naked:focus:not(:disabled) {\n  background-color: #e3e3e3;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--naked:active:not(:disabled) {\n  background-color: #d6d6d6;\n  border-color: #d6d6d6;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-button--naked .tox-icon svg {\n  fill: currentColor;\n}\n.tox .tox-button--naked.tox-button--icon:hover:not(:disabled) {\n  color: #222f3e;\n}\n.tox .tox-checkbox {\n  align-items: center;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  height: 36px;\n  min-width: 36px;\n}\n.tox .tox-checkbox__input {\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  top: auto;\n  width: 1px;\n}\n.tox .tox-checkbox__icons {\n  align-items: center;\n  border-radius: 3px;\n  box-shadow: 0 0 0 2px transparent;\n  box-sizing: content-box;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  padding: calc(4px - 1px);\n  width: 24px;\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  display: block;\n  fill: rgba(34, 47, 62, 0.3);\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {\n  display: none;\n  fill: #207ab7;\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__checked svg {\n  display: none;\n  fill: #207ab7;\n}\n.tox .tox-checkbox--disabled {\n  color: rgba(34, 47, 62, 0.5);\n  cursor: not-allowed;\n}\n.tox\n  .tox-checkbox--disabled\n  .tox-checkbox__icons\n  .tox-checkbox-icon__checked\n  svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox\n  .tox-checkbox--disabled\n  .tox-checkbox__icons\n  .tox-checkbox-icon__unchecked\n  svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox\n  .tox-checkbox--disabled\n  .tox-checkbox__icons\n  .tox-checkbox-icon__indeterminate\n  svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox\n  input.tox-checkbox__input:checked\n  + .tox-checkbox__icons\n  .tox-checkbox-icon__unchecked\n  svg {\n  display: none;\n}\n.tox\n  input.tox-checkbox__input:checked\n  + .tox-checkbox__icons\n  .tox-checkbox-icon__checked\n  svg {\n  display: block;\n}\n.tox\n  input.tox-checkbox__input:indeterminate\n  + .tox-checkbox__icons\n  .tox-checkbox-icon__unchecked\n  svg {\n  display: none;\n}\n.tox\n  input.tox-checkbox__input:indeterminate\n  + .tox-checkbox__icons\n  .tox-checkbox-icon__indeterminate\n  svg {\n  display: block;\n}\n.tox input.tox-checkbox__input:focus + .tox-checkbox__icons {\n  border-radius: 3px;\n  box-shadow: inset 0 0 0 1px #207ab7;\n  padding: calc(4px - 1px);\n}\n.tox:not([dir=\"rtl\"]) .tox-checkbox__label {\n  margin-left: 4px;\n}\n.tox:not([dir=\"rtl\"]) .tox-checkbox__input {\n  left: -10000px;\n}\n.tox:not([dir=\"rtl\"]) .tox-bar .tox-checkbox {\n  margin-left: 4px;\n}\n.tox[dir=\"rtl\"] .tox-checkbox__label {\n  margin-right: 4px;\n}\n.tox[dir=\"rtl\"] .tox-checkbox__input {\n  right: -10000px;\n}\n.tox[dir=\"rtl\"] .tox-bar .tox-checkbox {\n  margin-right: 4px;\n}\n.tox .tox-collection--toolbar .tox-collection__group {\n  display: flex;\n  padding: 0;\n}\n.tox .tox-collection--grid .tox-collection__group {\n  display: flex;\n  flex-wrap: wrap;\n  max-height: 208px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0;\n}\n.tox .tox-collection--list .tox-collection__group {\n  border-bottom-width: 0;\n  border-color: #ccc;\n  border-left-width: 0;\n  border-right-width: 0;\n  border-style: solid;\n  border-top-width: 1px;\n  padding: 4px 0;\n}\n.tox .tox-collection--list .tox-collection__group:first-child {\n  border-top-width: 0;\n}\n.tox .tox-collection__group-heading {\n  background-color: #e6e6e6;\n  color: rgba(34, 47, 62, 0.7);\n  cursor: default;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  margin-bottom: 4px;\n  margin-top: -4px;\n  padding: 4px 8px;\n  text-transform: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.tox .tox-collection__item {\n  align-items: center;\n  color: #222f3e;\n  cursor: pointer;\n  display: flex;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.tox .tox-collection--list .tox-collection__item {\n  padding: 4px 8px;\n}\n.tox .tox-collection--toolbar .tox-collection__item {\n  border-radius: 3px;\n  padding: 4px;\n}\n.tox .tox-collection--grid .tox-collection__item {\n  border-radius: 3px;\n  padding: 4px;\n}\n.tox .tox-collection--list .tox-collection__item--enabled {\n  background-color: #fff;\n  color: #222f3e;\n}\n.tox .tox-collection--list .tox-collection__item--active {\n  background-color: #dee0e2;\n}\n.tox .tox-collection--toolbar .tox-collection__item--enabled {\n  background-color: #c8cbcf;\n  color: #222f3e;\n}\n.tox .tox-collection--toolbar .tox-collection__item--active {\n  background-color: #dee0e2;\n}\n.tox .tox-collection--grid .tox-collection__item--enabled {\n  background-color: #c8cbcf;\n  color: #222f3e;\n}\n.tox\n  .tox-collection--grid\n  .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  background-color: #dee0e2;\n  color: #222f3e;\n}\n.tox\n  .tox-collection--list\n  .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  color: #222f3e;\n}\n.tox\n  .tox-collection--toolbar\n  .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  color: #222f3e;\n}\n.tox .tox-collection__item-checkmark,\n.tox .tox-collection__item-icon {\n  align-items: center;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  width: 24px;\n}\n.tox .tox-collection__item-checkmark svg,\n.tox .tox-collection__item-icon svg {\n  fill: currentColor;\n}\n.tox .tox-collection--toolbar-lg .tox-collection__item-icon {\n  height: 48px;\n  width: 48px;\n}\n.tox .tox-collection__item-label {\n  color: currentColor;\n  display: inline-block;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  text-transform: none;\n  word-break: break-all;\n}\n.tox .tox-collection__item-accessory {\n  color: rgba(34, 47, 62, 0.7);\n  display: inline-block;\n  font-size: 14px;\n  height: 24px;\n  line-height: 24px;\n  text-transform: none;\n}\n.tox .tox-collection__item-caret {\n  align-items: center;\n  display: flex;\n  min-height: 24px;\n}\n.tox .tox-collection__item-caret::after {\n  content: \"\";\n  font-size: 0;\n  min-height: inherit;\n}\n.tox .tox-collection__item-caret svg {\n  fill: #222f3e;\n}\n.tox .tox-collection__item--state-disabled {\n  background-color: transparent;\n  color: rgba(34, 47, 62, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-collection__item--state-disabled .tox-collection__item-caret svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox\n  .tox-collection--list\n  .tox-collection__item:not(.tox-collection__item--enabled)\n  .tox-collection__item-checkmark\n  svg {\n  display: none;\n}\n.tox\n  .tox-collection--list\n  .tox-collection__item:not(.tox-collection__item--enabled)\n  .tox-collection__item-accessory\n  + .tox-collection__item-checkmark {\n  display: none;\n}\n.tox .tox-collection--horizontal {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex: 0 0 auto;\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n  margin-bottom: 0;\n  overflow-x: auto;\n  padding: 0;\n}\n.tox .tox-collection--horizontal .tox-collection__group {\n  align-items: center;\n  display: flex;\n  flex-wrap: nowrap;\n  margin: 0;\n  padding: 0 4px;\n}\n.tox .tox-collection--horizontal .tox-collection__item {\n  height: 34px;\n  margin: 2px 0 3px 0;\n  padding: 0 4px;\n}\n.tox .tox-collection--horizontal .tox-collection__item-label {\n  white-space: nowrap;\n}\n.tox .tox-collection--horizontal .tox-collection__item-caret {\n  margin-left: 4px;\n}\n.tox .tox-collection__item-container {\n  display: flex;\n}\n.tox .tox-collection__item-container--row {\n  align-items: center;\n  flex: 1 1 auto;\n  flex-direction: row;\n}\n.tox\n  .tox-collection__item-container--row.tox-collection__item-container--align-left {\n  margin-right: auto;\n}\n.tox\n  .tox-collection__item-container--row.tox-collection__item-container--align-right {\n  justify-content: flex-end;\n  margin-left: auto;\n}\n.tox\n  .tox-collection__item-container--row.tox-collection__item-container--valign-top {\n  align-items: flex-start;\n  margin-bottom: auto;\n}\n.tox\n  .tox-collection__item-container--row.tox-collection__item-container--valign-middle {\n  align-items: center;\n}\n.tox\n  .tox-collection__item-container--row.tox-collection__item-container--valign-bottom {\n  align-items: flex-end;\n  margin-top: auto;\n}\n.tox .tox-collection__item-container--column {\n  -ms-grid-row-align: center;\n  align-self: center;\n  flex: 1 1 auto;\n  flex-direction: column;\n}\n.tox\n  .tox-collection__item-container--column.tox-collection__item-container--align-left {\n  align-items: flex-start;\n}\n.tox\n  .tox-collection__item-container--column.tox-collection__item-container--align-right {\n  align-items: flex-end;\n}\n.tox\n  .tox-collection__item-container--column.tox-collection__item-container--valign-top {\n  align-self: flex-start;\n}\n.tox\n  .tox-collection__item-container--column.tox-collection__item-container--valign-middle {\n  -ms-grid-row-align: center;\n  align-self: center;\n}\n.tox\n  .tox-collection__item-container--column.tox-collection__item-container--valign-bottom {\n  align-self: flex-end;\n}\n.tox:not([dir=\"rtl\"])\n  .tox-collection--horizontal\n  .tox-collection__group:not(:last-of-type) {\n  border-right: 1px solid #ccc;\n}\n.tox:not([dir=\"rtl\"])\n  .tox-collection--list\n  .tox-collection__item\n  > :not(:first-child) {\n  margin-left: 8px;\n}\n.tox:not([dir=\"rtl\"])\n  .tox-collection--list\n  .tox-collection__item\n  > .tox-collection__item-label:first-child {\n  margin-left: 4px;\n}\n.tox:not([dir=\"rtl\"]) .tox-collection__item-accessory {\n  margin-left: 16px;\n  text-align: right;\n}\n.tox:not([dir=\"rtl\"]) .tox-collection .tox-collection__item-caret {\n  margin-left: 16px;\n}\n.tox[dir=\"rtl\"]\n  .tox-collection--horizontal\n  .tox-collection__group:not(:last-of-type) {\n  border-left: 1px solid #ccc;\n}\n.tox[dir=\"rtl\"]\n  .tox-collection--list\n  .tox-collection__item\n  > :not(:first-child) {\n  margin-right: 8px;\n}\n.tox[dir=\"rtl\"]\n  .tox-collection--list\n  .tox-collection__item\n  > .tox-collection__item-label:first-child {\n  margin-right: 4px;\n}\n.tox[dir=\"rtl\"] .tox-collection__item-accessory {\n  margin-right: 16px;\n  text-align: left;\n}\n.tox[dir=\"rtl\"] .tox-collection .tox-collection__item-caret {\n  margin-right: 16px;\n  transform: rotateY(180deg);\n}\n.tox[dir=\"rtl\"] .tox-collection--horizontal .tox-collection__item-caret {\n  margin-right: 4px;\n}\n.tox .tox-color-picker-container {\n  display: flex;\n  flex-direction: row;\n  height: 225px;\n  margin: 0;\n}\n.tox .tox-sv-palette {\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n}\n.tox .tox-sv-palette-spectrum {\n  height: 100%;\n}\n.tox .tox-sv-palette,\n.tox .tox-sv-palette-spectrum {\n  width: 225px;\n}\n.tox .tox-sv-palette-thumb {\n  background: 0 0;\n  border: 1px solid #000;\n  border-radius: 50%;\n  box-sizing: content-box;\n  height: 12px;\n  position: absolute;\n  width: 12px;\n}\n.tox .tox-sv-palette-inner-thumb {\n  border: 1px solid #fff;\n  border-radius: 50%;\n  height: 10px;\n  position: absolute;\n  width: 10px;\n}\n.tox .tox-hue-slider {\n  box-sizing: border-box;\n  height: 100%;\n  width: 25px;\n}\n.tox .tox-hue-slider-spectrum {\n  background: linear-gradient(\n    to bottom,\n    red,\n    #ff0080,\n    #f0f,\n    #8000ff,\n    #00f,\n    #0080ff,\n    #0ff,\n    #00ff80,\n    #0f0,\n    #80ff00,\n    #ff0,\n    #ff8000,\n    red\n  );\n  height: 100%;\n  width: 100%;\n}\n.tox .tox-hue-slider,\n.tox .tox-hue-slider-spectrum {\n  width: 20px;\n}\n.tox .tox-hue-slider-thumb {\n  background: #fff;\n  border: 1px solid #000;\n  box-sizing: content-box;\n  height: 4px;\n  width: 100%;\n}\n.tox .tox-rgb-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.tox .tox-rgb-form div {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  width: inherit;\n}\n.tox .tox-rgb-form input {\n  width: 6em;\n}\n.tox .tox-rgb-form input.tox-invalid {\n  border: 1px solid red !important;\n}\n.tox .tox-rgb-form .tox-rgba-preview {\n  border: 1px solid #000;\n  flex-grow: 2;\n  margin-bottom: 0;\n}\n.tox:not([dir=\"rtl\"]) .tox-sv-palette {\n  margin-right: 15px;\n}\n.tox:not([dir=\"rtl\"]) .tox-hue-slider {\n  margin-right: 15px;\n}\n.tox:not([dir=\"rtl\"]) .tox-hue-slider-thumb {\n  margin-left: -1px;\n}\n.tox:not([dir=\"rtl\"]) .tox-rgb-form label {\n  margin-right: 0.5em;\n}\n.tox[dir=\"rtl\"] .tox-sv-palette {\n  margin-left: 15px;\n}\n.tox[dir=\"rtl\"] .tox-hue-slider {\n  margin-left: 15px;\n}\n.tox[dir=\"rtl\"] .tox-hue-slider-thumb {\n  margin-right: -1px;\n}\n.tox[dir=\"rtl\"] .tox-rgb-form label {\n  margin-left: 0.5em;\n}\n.tox .tox-toolbar .tox-swatches,\n.tox .tox-toolbar__overflow .tox-swatches,\n.tox .tox-toolbar__primary .tox-swatches {\n  margin: 2px 0 3px 4px;\n}\n.tox .tox-collection--list .tox-collection__group .tox-swatches-menu {\n  border: 0;\n  margin: -4px 0;\n}\n.tox .tox-swatches__row {\n  display: flex;\n}\n.tox .tox-swatch {\n  height: 30px;\n  transition:\n    transform 0.15s,\n    box-shadow 0.15s;\n  width: 30px;\n}\n.tox .tox-swatch:focus,\n.tox .tox-swatch:hover {\n  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.3) inset;\n  transform: scale(0.8);\n}\n.tox .tox-swatch--remove {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.tox .tox-swatch--remove svg path {\n  stroke: #e74c3c;\n}\n.tox .tox-swatches__picker-btn {\n  align-items: center;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  display: flex;\n  height: 30px;\n  justify-content: center;\n  outline: 0;\n  padding: 0;\n  width: 30px;\n}\n.tox .tox-swatches__picker-btn svg {\n  height: 24px;\n  width: 24px;\n}\n.tox .tox-swatches__picker-btn:hover {\n  background: #dee0e2;\n}\n.tox:not([dir=\"rtl\"]) .tox-swatches__picker-btn {\n  margin-left: auto;\n}\n.tox[dir=\"rtl\"] .tox-swatches__picker-btn {\n  margin-right: auto;\n}\n.tox .tox-comment-thread {\n  background: #fff;\n  position: relative;\n}\n.tox .tox-comment-thread > :not(:first-child) {\n  margin-top: 8px;\n}\n.tox .tox-comment {\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);\n  padding: 8px 8px 16px 8px;\n  position: relative;\n}\n.tox .tox-comment__header {\n  align-items: center;\n  color: #222f3e;\n  display: flex;\n  justify-content: space-between;\n}\n.tox .tox-comment__date {\n  color: rgba(34, 47, 62, 0.7);\n  font-size: 12px;\n}\n.tox .tox-comment__body {\n  color: #222f3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.3;\n  margin-top: 8px;\n  position: relative;\n  text-transform: initial;\n}\n.tox .tox-comment__body textarea {\n  resize: none;\n  white-space: normal;\n  width: 100%;\n}\n.tox .tox-comment__expander {\n  padding-top: 8px;\n}\n.tox .tox-comment__expander p {\n  color: rgba(34, 47, 62, 0.7);\n  font-size: 14px;\n  font-style: normal;\n}\n.tox .tox-comment__body p {\n  margin: 0;\n}\n.tox .tox-comment__buttonspacing {\n  padding-top: 16px;\n  text-align: center;\n}\n.tox .tox-comment-thread__overlay::after {\n  background: #fff;\n  bottom: 0;\n  content: \"\";\n  display: flex;\n  left: 0;\n  opacity: 0.9;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 5;\n}\n.tox .tox-comment__reply {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 8px;\n}\n.tox .tox-comment__reply > :first-child {\n  margin-bottom: 8px;\n  width: 100%;\n}\n.tox .tox-comment__edit {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n.tox .tox-comment__gradient::after {\n  background: linear-gradient(rgba(255, 255, 255, 0), #fff);\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 5em;\n  margin-top: -40px;\n  position: absolute;\n  width: 100%;\n}\n.tox .tox-comment__overlay {\n  background: #fff;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  left: 0;\n  opacity: 0.9;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 0;\n  z-index: 5;\n}\n.tox .tox-comment__loading-text {\n  align-items: center;\n  color: #222f3e;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.tox .tox-comment__loading-text > div {\n  padding-bottom: 16px;\n}\n.tox .tox-comment__overlaytext {\n  bottom: 0;\n  flex-direction: column;\n  font-size: 14px;\n  left: 0;\n  padding: 1em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n}\n.tox .tox-comment__overlaytext p {\n  background-color: #fff;\n  box-shadow: 0 0 8px 8px #fff;\n  color: #222f3e;\n  text-align: center;\n}\n.tox .tox-comment__overlaytext div:nth-of-type(2) {\n  font-size: 0.8em;\n}\n.tox .tox-comment__busy-spinner {\n  align-items: center;\n  background-color: #fff;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 20;\n}\n.tox .tox-comment__scroll {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 1;\n  overflow: auto;\n}\n.tox .tox-conversations {\n  margin: 8px;\n}\n.tox:not([dir=\"rtl\"]) .tox-comment__edit {\n  margin-left: 8px;\n}\n.tox:not([dir=\"rtl\"]) .tox-comment__buttonspacing > :last-child,\n.tox:not([dir=\"rtl\"]) .tox-comment__edit > :last-child,\n.tox:not([dir=\"rtl\"]) .tox-comment__reply > :last-child {\n  margin-left: 8px;\n}\n.tox[dir=\"rtl\"] .tox-comment__edit {\n  margin-right: 8px;\n}\n.tox[dir=\"rtl\"] .tox-comment__buttonspacing > :last-child,\n.tox[dir=\"rtl\"] .tox-comment__edit > :last-child,\n.tox[dir=\"rtl\"] .tox-comment__reply > :last-child {\n  margin-right: 8px;\n}\n.tox .tox-user {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-user__avatar svg {\n  fill: rgba(34, 47, 62, 0.7);\n}\n.tox .tox-user__name {\n  color: rgba(34, 47, 62, 0.7);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.tox:not([dir=\"rtl\"]) .tox-user__avatar svg {\n  margin-right: 8px;\n}\n.tox:not([dir=\"rtl\"]) .tox-user__avatar + .tox-user__name {\n  margin-left: 8px;\n}\n.tox[dir=\"rtl\"] .tox-user__avatar svg {\n  margin-left: 8px;\n}\n.tox[dir=\"rtl\"] .tox-user__avatar + .tox-user__name {\n  margin-right: 8px;\n}\n.tox .tox-dialog-wrap {\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1100;\n}\n.tox .tox-dialog-wrap__backdrop {\n  background-color: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.tox .tox-dialog-wrap__backdrop--opaque {\n  background-color: #fff;\n}\n.tox .tox-dialog {\n  background-color: #fff;\n  border-color: #ccc;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow:\n    0 16px 16px -10px rgba(34, 47, 62, 0.15),\n    0 0 40px 1px rgba(34, 47, 62, 0.15);\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n  max-width: 480px;\n  overflow: hidden;\n  position: relative;\n  width: 95vw;\n  z-index: 2;\n}\n@media only screen and (max-width: 767px) {\n  body:not(.tox-force-desktop) .tox .tox-dialog {\n    align-self: flex-start;\n    margin: 8px auto;\n    width: calc(100vw - 16px);\n  }\n}\n.tox .tox-dialog-inline {\n  z-index: 1100;\n}\n.tox .tox-dialog__header {\n  align-items: center;\n  background-color: #fff;\n  border-bottom: none;\n  color: #222f3e;\n  display: flex;\n  font-size: 16px;\n  justify-content: space-between;\n  padding: 8px 16px 0 16px;\n  position: relative;\n}\n.tox .tox-dialog__header .tox-button {\n  z-index: 1;\n}\n.tox .tox-dialog__draghandle {\n  cursor: grab;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.tox .tox-dialog__draghandle:active {\n  cursor: grabbing;\n}\n.tox .tox-dialog__dismiss {\n  margin-left: auto;\n}\n.tox .tox-dialog__title {\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.3;\n  margin: 0;\n  text-transform: none;\n}\n.tox .tox-dialog__body {\n  color: #222f3e;\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.3;\n  min-width: 0;\n  text-align: left;\n  text-transform: none;\n}\n@media only screen and (max-width: 767px) {\n  body:not(.tox-force-desktop) .tox .tox-dialog__body {\n    flex-direction: column;\n  }\n}\n.tox .tox-dialog__body-nav {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px;\n}\n@media only screen and (max-width: 767px) {\n  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav {\n    flex-direction: row;\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n    padding-bottom: 0;\n  }\n}\n.tox .tox-dialog__body-nav-item {\n  border-bottom: 2px solid transparent;\n  color: rgba(34, 47, 62, 0.7);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 1.3;\n  margin-bottom: 8px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n.tox .tox-dialog__body-nav-item:focus {\n  background-color: rgba(32, 122, 183, 0.1);\n}\n.tox .tox-dialog__body-nav-item--active {\n  border-bottom: 2px solid #207ab7;\n  color: #207ab7;\n}\n.tox .tox-dialog__body-content {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  -ms-flex-preferred-size: auto;\n  max-height: 650px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 16px 16px;\n}\n.tox .tox-dialog__body-content > * {\n  margin-bottom: 0;\n  margin-top: 16px;\n}\n.tox .tox-dialog__body-content > :first-child {\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content > :last-child {\n  margin-bottom: 0;\n}\n.tox .tox-dialog__body-content > :only-child {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content a {\n  color: #207ab7;\n  cursor: pointer;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content a:focus,\n.tox .tox-dialog__body-content a:hover {\n  color: #185d8c;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content a:active {\n  color: #185d8c;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content svg {\n  fill: #222f3e;\n}\n.tox .tox-dialog__body-content ul {\n  display: block;\n  list-style-type: disc;\n  margin-bottom: 16px;\n  -webkit-margin-end: 0;\n  margin-inline-end: 0;\n  -webkit-margin-start: 0;\n  margin-inline-start: 0;\n  -webkit-padding-start: 2.5rem;\n  padding-inline-start: 2.5rem;\n}\n.tox .tox-dialog__body-content .tox-form__group h1 {\n  color: #222f3e;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: normal;\n  margin-bottom: 16px;\n  margin-top: 2rem;\n  text-transform: none;\n}\n.tox .tox-dialog__body-content .tox-form__group h2 {\n  color: #222f3e;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: normal;\n  margin-bottom: 16px;\n  margin-top: 2rem;\n  text-transform: none;\n}\n.tox .tox-dialog__body-content .tox-form__group p {\n  margin-bottom: 16px;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:first-child,\n.tox .tox-dialog__body-content .tox-form__group h2:first-child,\n.tox .tox-dialog__body-content .tox-form__group p:first-child {\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:last-child,\n.tox .tox-dialog__body-content .tox-form__group h2:last-child,\n.tox .tox-dialog__body-content .tox-form__group p:last-child {\n  margin-bottom: 0;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:only-child,\n.tox .tox-dialog__body-content .tox-form__group h2:only-child,\n.tox .tox-dialog__body-content .tox-form__group p:only-child {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.tox .tox-dialog--width-lg {\n  height: 650px;\n  max-width: 1200px;\n}\n.tox .tox-dialog--width-md {\n  max-width: 800px;\n}\n.tox .tox-dialog--width-md .tox-dialog__body-content {\n  overflow: auto;\n}\n.tox .tox-dialog__body-content--centered {\n  text-align: center;\n}\n.tox .tox-dialog__footer {\n  align-items: center;\n  background-color: #fff;\n  border-top: 1px solid #ccc;\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 16px;\n}\n.tox .tox-dialog__footer-end,\n.tox .tox-dialog__footer-start {\n  display: flex;\n}\n.tox .tox-dialog__busy-spinner {\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 3;\n}\n.tox .tox-dialog__table {\n  border-collapse: collapse;\n  width: 100%;\n}\n.tox .tox-dialog__table thead th {\n  font-weight: 700;\n  padding-bottom: 8px;\n}\n.tox .tox-dialog__table tbody tr {\n  border-bottom: 1px solid #ccc;\n}\n.tox .tox-dialog__table tbody tr:last-child {\n  border-bottom: none;\n}\n.tox .tox-dialog__table td {\n  padding-bottom: 8px;\n  padding-top: 8px;\n}\n.tox .tox-dialog__popups {\n  position: absolute;\n  width: 100%;\n  z-index: 1100;\n}\n.tox .tox-dialog__body-iframe {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-dialog__body-iframe .tox-navobj {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-dialog__body-iframe .tox-navobj :nth-child(2) {\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  height: 100%;\n}\n.tox .tox-dialog-dock-fadeout {\n  opacity: 0;\n  visibility: hidden;\n}\n.tox .tox-dialog-dock-fadein {\n  opacity: 1;\n  visibility: visible;\n}\n.tox .tox-dialog-dock-transition {\n  transition:\n    visibility 0s linear 0.3s,\n    opacity 0.3s ease;\n}\n.tox .tox-dialog-dock-transition.tox-dialog-dock-fadein {\n  transition-delay: 0s;\n}\n.tox.tox-platform-ie .tox-dialog-wrap {\n  position: -ms-device-fixed;\n}\n@media only screen and (max-width: 767px) {\n  body:not(.tox-force-desktop) .tox:not([dir=\"rtl\"]) .tox-dialog__body-nav {\n    margin-right: 0;\n  }\n}\n@media only screen and (max-width: 767px) {\n  body:not(.tox-force-desktop)\n    .tox:not([dir=\"rtl\"])\n    .tox-dialog__body-nav-item:not(:first-child) {\n    margin-left: 8px;\n  }\n}\n.tox:not([dir=\"rtl\"]) .tox-dialog__footer .tox-dialog__footer-end > *,\n.tox:not([dir=\"rtl\"]) .tox-dialog__footer .tox-dialog__footer-start > * {\n  margin-left: 8px;\n}\n.tox[dir=\"rtl\"] .tox-dialog__body {\n  text-align: right;\n}\n@media only screen and (max-width: 767px) {\n  body:not(.tox-force-desktop) .tox[dir=\"rtl\"] .tox-dialog__body-nav {\n    margin-left: 0;\n  }\n}\n@media only screen and (max-width: 767px) {\n  body:not(.tox-force-desktop)\n    .tox[dir=\"rtl\"]\n    .tox-dialog__body-nav-item:not(:first-child) {\n    margin-right: 8px;\n  }\n}\n.tox[dir=\"rtl\"] .tox-dialog__footer .tox-dialog__footer-end > *,\n.tox[dir=\"rtl\"] .tox-dialog__footer .tox-dialog__footer-start > * {\n  margin-right: 8px;\n}\nbody.tox-dialog__disable-scroll {\n  overflow: hidden;\n}\n.tox .tox-dropzone-container {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-dropzone {\n  align-items: center;\n  background: #fff;\n  border: 2px dashed #ccc;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  min-height: 100px;\n  padding: 10px;\n}\n.tox .tox-dropzone p {\n  color: rgba(34, 47, 62, 0.7);\n  margin: 0 0 16px 0;\n}\n.tox .tox-edit-area {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  overflow: hidden;\n  position: relative;\n}\n.tox .tox-edit-area__iframe {\n  background-color: #fff;\n  border: 0;\n  box-sizing: border-box;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.tox.tox-inline-edit-area {\n  border: 1px dotted #ccc;\n}\n.tox .tox-editor-container {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  overflow: hidden;\n}\n.tox .tox-editor-header {\n  z-index: 1;\n}\n.tox:not(.tox-tinymce-inline) .tox-editor-header {\n  box-shadow: none;\n  transition: box-shadow 0.5s;\n}\n.tox.tox-tinymce--toolbar-bottom .tox-editor-header,\n.tox.tox-tinymce-inline .tox-editor-header {\n  margin-bottom: -1px;\n}\n.tox.tox-tinymce--toolbar-sticky-on .tox-editor-header {\n  background-color: transparent;\n  box-shadow: 0 4px 4px -3px rgba(0, 0, 0, 0.25);\n}\n.tox-editor-dock-fadeout {\n  opacity: 0;\n  visibility: hidden;\n}\n.tox-editor-dock-fadein {\n  opacity: 1;\n  visibility: visible;\n}\n.tox-editor-dock-transition {\n  transition:\n    visibility 0s linear 0.25s,\n    opacity 0.25s ease;\n}\n.tox-editor-dock-transition.tox-editor-dock-fadein {\n  transition-delay: 0s;\n}\n.tox .tox-control-wrap {\n  flex: 1;\n  position: relative;\n}\n.tox\n  .tox-control-wrap:not(.tox-control-wrap--status-invalid)\n  .tox-control-wrap__status-icon-invalid,\n.tox\n  .tox-control-wrap:not(.tox-control-wrap--status-unknown)\n  .tox-control-wrap__status-icon-unknown,\n.tox\n  .tox-control-wrap:not(.tox-control-wrap--status-valid)\n  .tox-control-wrap__status-icon-valid {\n  display: none;\n}\n.tox .tox-control-wrap svg {\n  display: block;\n}\n.tox .tox-control-wrap__status-icon-wrap {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-control-wrap__status-icon-invalid svg {\n  fill: #c00;\n}\n.tox .tox-control-wrap__status-icon-unknown svg {\n  fill: orange;\n}\n.tox .tox-control-wrap__status-icon-valid svg {\n  fill: green;\n}\n.tox:not([dir=\"rtl\"]) .tox-control-wrap--status-invalid .tox-textfield,\n.tox:not([dir=\"rtl\"]) .tox-control-wrap--status-unknown .tox-textfield,\n.tox:not([dir=\"rtl\"]) .tox-control-wrap--status-valid .tox-textfield {\n  padding-right: 32px;\n}\n.tox:not([dir=\"rtl\"]) .tox-control-wrap__status-icon-wrap {\n  right: 4px;\n}\n.tox[dir=\"rtl\"] .tox-control-wrap--status-invalid .tox-textfield,\n.tox[dir=\"rtl\"] .tox-control-wrap--status-unknown .tox-textfield,\n.tox[dir=\"rtl\"] .tox-control-wrap--status-valid .tox-textfield {\n  padding-left: 32px;\n}\n.tox[dir=\"rtl\"] .tox-control-wrap__status-icon-wrap {\n  left: 4px;\n}\n.tox .tox-autocompleter {\n  max-width: 25em;\n}\n.tox .tox-autocompleter .tox-menu {\n  max-width: 25em;\n}\n.tox .tox-autocompleter .tox-autocompleter-highlight {\n  font-weight: 700;\n}\n.tox .tox-color-input {\n  display: flex;\n  position: relative;\n  z-index: 1;\n}\n.tox .tox-color-input .tox-textfield {\n  z-index: -1;\n}\n.tox .tox-color-input span {\n  border-color: rgba(34, 47, 62, 0.2);\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  height: 24px;\n  position: absolute;\n  top: 6px;\n  width: 24px;\n}\n.tox .tox-color-input span:focus:not([aria-disabled=\"true\"]),\n.tox .tox-color-input span:hover:not([aria-disabled=\"true\"]) {\n  border-color: #207ab7;\n  cursor: pointer;\n}\n.tox .tox-color-input span::before {\n  background-image:\n    linear-gradient(45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%),\n    linear-gradient(-45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%),\n    linear-gradient(-45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%);\n  background-position:\n    0 0,\n    0 6px,\n    6px -6px,\n    -6px 0;\n  background-size: 12px 12px;\n  border: 1px solid #fff;\n  border-radius: 3px;\n  box-sizing: border-box;\n  content: \"\";\n  height: 24px;\n  left: -1px;\n  position: absolute;\n  top: -1px;\n  width: 24px;\n  z-index: -1;\n}\n.tox .tox-color-input span[aria-disabled=\"true\"] {\n  cursor: not-allowed;\n}\n.tox:not([dir=\"rtl\"]) .tox-color-input .tox-textfield {\n  padding-left: 36px;\n}\n.tox:not([dir=\"rtl\"]) .tox-color-input span {\n  left: 6px;\n}\n.tox[dir=\"rtl\"] .tox-color-input .tox-textfield {\n  padding-right: 36px;\n}\n.tox[dir=\"rtl\"] .tox-color-input span {\n  right: 6px;\n}\n.tox .tox-label,\n.tox .tox-toolbar-label {\n  color: rgba(34, 47, 62, 0.7);\n  display: block;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.3;\n  padding: 0 8px 0 0;\n  text-transform: none;\n  white-space: nowrap;\n}\n.tox .tox-toolbar-label {\n  padding: 0 8px;\n}\n.tox[dir=\"rtl\"] .tox-label {\n  padding: 0 0 0 8px;\n}\n.tox .tox-form {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-form__group {\n  box-sizing: border-box;\n  margin-bottom: 4px;\n}\n.tox .tox-form-group--maximize {\n  flex: 1;\n}\n.tox .tox-form__group--error {\n  color: #c00;\n}\n.tox .tox-form__group--collection {\n  display: flex;\n}\n.tox .tox-form__grid {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.tox .tox-form__grid--2col > .tox-form__group {\n  width: calc(50% - (8px / 2));\n}\n.tox .tox-form__grid--3col > .tox-form__group {\n  width: calc(100% / 3 - (8px / 2));\n}\n.tox .tox-form__grid--4col > .tox-form__group {\n  width: calc(25% - (8px / 2));\n}\n.tox .tox-form__controls-h-stack {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-form__group--inline {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-form__group--stretched {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-form__group--stretched .tox-textarea {\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-form__group--stretched .tox-navobj {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-form__group--stretched .tox-navobj :nth-child(2) {\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  height: 100%;\n}\n.tox:not([dir=\"rtl\"]) .tox-form__controls-h-stack > :not(:first-child) {\n  margin-left: 4px;\n}\n.tox[dir=\"rtl\"] .tox-form__controls-h-stack > :not(:first-child) {\n  margin-right: 4px;\n}\n.tox .tox-lock.tox-locked .tox-lock-icon__unlock,\n.tox .tox-lock:not(.tox-locked) .tox-lock-icon__lock {\n  display: none;\n}\n.tox .tox-listboxfield .tox-listbox--select,\n.tox .tox-textarea,\n.tox .tox-textfield,\n.tox .tox-toolbar-textfield {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  border-color: #ccc;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: #222f3e;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n  min-height: 34px;\n  outline: 0;\n  padding: 5px 4.75px;\n  resize: none;\n  width: 100%;\n}\n.tox .tox-textarea[disabled],\n.tox .tox-textfield[disabled] {\n  background-color: #f2f2f2;\n  color: rgba(34, 47, 62, 0.85);\n  cursor: not-allowed;\n}\n.tox .tox-listboxfield .tox-listbox--select:focus,\n.tox .tox-textarea:focus,\n.tox .tox-textfield:focus {\n  background-color: #fff;\n  border-color: #207ab7;\n  box-shadow: none;\n  outline: 0;\n}\n.tox .tox-toolbar-textfield {\n  border-width: 0;\n  margin-bottom: 3px;\n  margin-top: 2px;\n  max-width: 250px;\n}\n.tox .tox-naked-btn {\n  background-color: transparent;\n  border: 0;\n  border-color: transparent;\n  box-shadow: unset;\n  color: #207ab7;\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.tox .tox-naked-btn svg {\n  display: block;\n  fill: #222f3e;\n}\n.tox:not([dir=\"rtl\"]) .tox-toolbar-textfield + * {\n  margin-left: 4px;\n}\n.tox[dir=\"rtl\"] .tox-toolbar-textfield + * {\n  margin-right: 4px;\n}\n.tox .tox-listboxfield {\n  cursor: pointer;\n  position: relative;\n}\n.tox .tox-listboxfield .tox-listbox--select[disabled] {\n  background-color: #f2f2f2;\n  color: rgba(34, 47, 62, 0.85);\n  cursor: not-allowed;\n}\n.tox .tox-listbox__select-label {\n  cursor: default;\n  flex: 1;\n  margin: 0 4px;\n}\n.tox .tox-listbox__select-chevron {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 16px;\n}\n.tox .tox-listbox__select-chevron svg {\n  fill: #222f3e;\n}\n.tox .tox-listboxfield .tox-listbox--select {\n  align-items: center;\n  display: flex;\n}\n.tox:not([dir=\"rtl\"]) .tox-listboxfield svg {\n  right: 8px;\n}\n.tox[dir=\"rtl\"] .tox-listboxfield svg {\n  left: 8px;\n}\n.tox .tox-selectfield {\n  cursor: pointer;\n  position: relative;\n}\n.tox .tox-selectfield select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  border-color: #ccc;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: #222f3e;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n  min-height: 34px;\n  outline: 0;\n  padding: 5px 4.75px;\n  resize: none;\n  width: 100%;\n}\n.tox .tox-selectfield select[disabled] {\n  background-color: #f2f2f2;\n  color: rgba(34, 47, 62, 0.85);\n  cursor: not-allowed;\n}\n.tox .tox-selectfield select::-ms-expand {\n  display: none;\n}\n.tox .tox-selectfield select:focus {\n  background-color: #fff;\n  border-color: #207ab7;\n  box-shadow: none;\n  outline: 0;\n}\n.tox .tox-selectfield svg {\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox:not([dir=\"rtl\"]) .tox-selectfield select[size=\"0\"],\n.tox:not([dir=\"rtl\"]) .tox-selectfield select[size=\"1\"] {\n  padding-right: 24px;\n}\n.tox:not([dir=\"rtl\"]) .tox-selectfield svg {\n  right: 8px;\n}\n.tox[dir=\"rtl\"] .tox-selectfield select[size=\"0\"],\n.tox[dir=\"rtl\"] .tox-selectfield select[size=\"1\"] {\n  padding-left: 24px;\n}\n.tox[dir=\"rtl\"] .tox-selectfield svg {\n  left: 8px;\n}\n.tox .tox-textarea {\n  -webkit-appearance: textarea;\n  -moz-appearance: textarea;\n  appearance: textarea;\n  white-space: pre-wrap;\n}\n.tox-fullscreen {\n  border: 0;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  -ms-scroll-chaining: none;\n  overscroll-behavior: none;\n  padding: 0;\n  touch-action: pinch-zoom;\n  width: 100%;\n}\n.tox.tox-tinymce.tox-fullscreen .tox-statusbar__resize-handle {\n  display: none;\n}\n.tox-shadowhost.tox-fullscreen,\n.tox.tox-tinymce.tox-fullscreen {\n  left: 0;\n  position: fixed;\n  top: 0;\n  z-index: 1200;\n}\n.tox.tox-tinymce.tox-fullscreen {\n  background-color: transparent;\n}\n.tox-fullscreen .tox.tox-tinymce-aux,\n.tox-fullscreen ~ .tox.tox-tinymce-aux {\n  z-index: 1201;\n}\n.tox .tox-help__more-link {\n  list-style: none;\n  margin-top: 1em;\n}\n.tox .tox-image-tools {\n  width: 100%;\n}\n.tox .tox-image-tools__toolbar {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.tox .tox-image-tools__image {\n  background-color: #666;\n  height: 380px;\n  overflow: auto;\n  position: relative;\n  width: 100%;\n}\n.tox .tox-image-tools__image,\n.tox .tox-image-tools__image + .tox-image-tools__toolbar {\n  margin-top: 8px;\n}\n.tox .tox-image-tools__image-bg {\n  background: url(data:image/gif;base64,R0lGODdhDAAMAIABAMzMzP///ywAAAAADAAMAAACFoQfqYeabNyDMkBQb81Uat85nxguUAEAOw==);\n}\n.tox .tox-image-tools__toolbar > .tox-spacer {\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-croprect-block {\n  background: #000;\n  opacity: 0.5;\n  position: absolute;\n  zoom: 1;\n}\n.tox .tox-croprect-handle {\n  border: 2px solid #fff;\n  height: 20px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 20px;\n}\n.tox .tox-croprect-handle-move {\n  border: 0;\n  cursor: move;\n  position: absolute;\n}\n.tox .tox-croprect-handle-nw {\n  border-width: 2px 0 0 2px;\n  cursor: nw-resize;\n  left: 100px;\n  margin: -2px 0 0 -2px;\n  top: 100px;\n}\n.tox .tox-croprect-handle-ne {\n  border-width: 2px 2px 0 0;\n  cursor: ne-resize;\n  left: 200px;\n  margin: -2px 0 0 -20px;\n  top: 100px;\n}\n.tox .tox-croprect-handle-sw {\n  border-width: 0 0 2px 2px;\n  cursor: sw-resize;\n  left: 100px;\n  margin: -20px 2px 0 -2px;\n  top: 200px;\n}\n.tox .tox-croprect-handle-se {\n  border-width: 0 2px 2px 0;\n  cursor: se-resize;\n  left: 200px;\n  margin: -20px 0 0 -20px;\n  top: 200px;\n}\n.tox:not([dir=\"rtl\"])\n  .tox-image-tools__toolbar\n  > .tox-slider:not(:first-of-type) {\n  margin-left: 8px;\n}\n.tox:not([dir=\"rtl\"]) .tox-image-tools__toolbar > .tox-button + .tox-slider {\n  margin-left: 32px;\n}\n.tox:not([dir=\"rtl\"]) .tox-image-tools__toolbar > .tox-slider + .tox-button {\n  margin-left: 32px;\n}\n.tox[dir=\"rtl\"] .tox-image-tools__toolbar > .tox-slider:not(:first-of-type) {\n  margin-right: 8px;\n}\n.tox[dir=\"rtl\"] .tox-image-tools__toolbar > .tox-button + .tox-slider {\n  margin-right: 32px;\n}\n.tox[dir=\"rtl\"] .tox-image-tools__toolbar > .tox-slider + .tox-button {\n  margin-right: 32px;\n}\n.tox .tox-insert-table-picker {\n  display: flex;\n  flex-wrap: wrap;\n  width: 170px;\n}\n.tox .tox-insert-table-picker > div {\n  border-color: #ccc;\n  border-style: solid;\n  border-width: 0 1px 1px 0;\n  box-sizing: border-box;\n  height: 17px;\n  width: 17px;\n}\n.tox .tox-collection--list .tox-collection__group .tox-insert-table-picker {\n  margin: -4px 0;\n}\n.tox .tox-insert-table-picker .tox-insert-table-picker__selected {\n  background-color: rgba(32, 122, 183, 0.5);\n  border-color: rgba(32, 122, 183, 0.5);\n}\n.tox .tox-insert-table-picker__label {\n  color: rgba(34, 47, 62, 0.7);\n  display: block;\n  font-size: 14px;\n  padding: 4px;\n  text-align: center;\n  width: 100%;\n}\n.tox:not([dir=\"rtl\"]) .tox-insert-table-picker > div:nth-child(10n) {\n  border-right: 0;\n}\n.tox[dir=\"rtl\"] .tox-insert-table-picker > div:nth-child(10n + 1) {\n  border-right: 0;\n}\n.tox .tox-menu {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: top;\n  z-index: 1150;\n}\n.tox .tox-menu.tox-collection.tox-collection--list {\n  padding: 0;\n}\n.tox .tox-menu.tox-collection.tox-collection--toolbar {\n  padding: 4px;\n}\n.tox .tox-menu.tox-collection.tox-collection--grid {\n  padding: 4px;\n}\n.tox .tox-menu__label blockquote,\n.tox .tox-menu__label code,\n.tox .tox-menu__label h1,\n.tox .tox-menu__label h2,\n.tox .tox-menu__label h3,\n.tox .tox-menu__label h4,\n.tox .tox-menu__label h5,\n.tox .tox-menu__label h6,\n.tox .tox-menu__label p {\n  margin: 0;\n}\n.tox .tox-menubar {\n  background: url(\"data:image/svg+xml;charset=utf8,%3Csvg height='39px' viewBox='0 0 40 39px' width='40' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0' y='38px' width='100' height='1' fill='%23cccccc'/%3E%3C/svg%3E\")\n    left 0 top 0 #fff;\n  background-color: #fff;\n  display: flex;\n  flex: 0 0 auto;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  padding: 0 4px 0 4px;\n}\n.tox.tox-tinymce:not(.tox-tinymce-inline)\n  .tox-editor-header:not(:first-child)\n  .tox-menubar {\n  border-top: 1px solid #ccc;\n}\n.tox .tox-mbtn {\n  align-items: center;\n  background: 0 0;\n  border: 0;\n  border-radius: 3px;\n  box-shadow: none;\n  color: #222f3e;\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  height: 34px;\n  justify-content: center;\n  margin: 2px 0 3px 0;\n  outline: 0;\n  overflow: hidden;\n  padding: 0 4px;\n  text-transform: none;\n  width: auto;\n}\n.tox .tox-mbtn[disabled] {\n  background-color: transparent;\n  border: 0;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-mbtn:focus:not(:disabled) {\n  background: #dee0e2;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-mbtn--active {\n  background: #c8cbcf;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {\n  background: #dee0e2;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-mbtn__select-label {\n  cursor: default;\n  font-weight: 400;\n  margin: 0 4px;\n}\n.tox .tox-mbtn[disabled] .tox-mbtn__select-label {\n  cursor: not-allowed;\n}\n.tox .tox-mbtn__select-chevron {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 16px;\n  display: none;\n}\n.tox .tox-notification {\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  display: -ms-grid;\n  display: grid;\n  font-size: 14px;\n  font-weight: 400;\n  -ms-grid-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);\n  grid-template-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);\n  margin-top: 4px;\n  opacity: 0;\n  padding: 4px;\n  transition:\n    transform 0.1s ease-in,\n    opacity 150ms ease-in;\n}\n.tox .tox-notification p {\n  font-size: 14px;\n  font-weight: 400;\n}\n.tox .tox-notification a {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.tox .tox-notification--in {\n  opacity: 1;\n}\n.tox .tox-notification--success {\n  background-color: #e4eeda;\n  border-color: #d7e6c8;\n  color: #222f3e;\n}\n.tox .tox-notification--success p {\n  color: #222f3e;\n}\n.tox .tox-notification--success a {\n  color: #547831;\n}\n.tox .tox-notification--success svg {\n  fill: #222f3e;\n}\n.tox .tox-notification--error {\n  background-color: #f8dede;\n  border-color: #f2bfbf;\n  color: #222f3e;\n}\n.tox .tox-notification--error p {\n  color: #222f3e;\n}\n.tox .tox-notification--error a {\n  color: #c00;\n}\n.tox .tox-notification--error svg {\n  fill: #222f3e;\n}\n.tox .tox-notification--warn,\n.tox .tox-notification--warning {\n  background-color: #fffaea;\n  border-color: #ffe89d;\n  color: #222f3e;\n}\n.tox .tox-notification--warn p,\n.tox .tox-notification--warning p {\n  color: #222f3e;\n}\n.tox .tox-notification--warn a,\n.tox .tox-notification--warning a {\n  color: #222f3e;\n}\n.tox .tox-notification--warn svg,\n.tox .tox-notification--warning svg {\n  fill: #222f3e;\n}\n.tox .tox-notification--info {\n  background-color: #d9edf7;\n  border-color: #779ecb;\n  color: #222f3e;\n}\n.tox .tox-notification--info p {\n  color: #222f3e;\n}\n.tox .tox-notification--info a {\n  color: #222f3e;\n}\n.tox .tox-notification--info svg {\n  fill: #222f3e;\n}\n.tox .tox-notification__body {\n  -ms-grid-row-align: center;\n  align-self: center;\n  color: #222f3e;\n  font-size: 14px;\n  -ms-grid-column-span: 1;\n  grid-column-end: 3;\n  -ms-grid-column: 2;\n  grid-column-start: 2;\n  -ms-grid-row-span: 1;\n  grid-row-end: 2;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n  text-align: center;\n  white-space: normal;\n  word-break: break-all;\n  word-break: break-word;\n}\n.tox .tox-notification__body > * {\n  margin: 0;\n}\n.tox .tox-notification__body > * + * {\n  margin-top: 1rem;\n}\n.tox .tox-notification__icon {\n  -ms-grid-row-align: center;\n  align-self: center;\n  -ms-grid-column-span: 1;\n  grid-column-end: 2;\n  -ms-grid-column: 1;\n  grid-column-start: 1;\n  -ms-grid-row-span: 1;\n  grid-row-end: 2;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n  -ms-grid-column-align: end;\n  justify-self: end;\n}\n.tox .tox-notification__icon svg {\n  display: block;\n}\n.tox .tox-notification__dismiss {\n  -ms-grid-row-align: start;\n  align-self: start;\n  -ms-grid-column-span: 1;\n  grid-column-end: 4;\n  -ms-grid-column: 3;\n  grid-column-start: 3;\n  -ms-grid-row-span: 1;\n  grid-row-end: 2;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n  -ms-grid-column-align: end;\n  justify-self: end;\n}\n.tox .tox-notification .tox-progress-bar {\n  -ms-grid-column-span: 3;\n  grid-column-end: 4;\n  -ms-grid-column: 1;\n  grid-column-start: 1;\n  -ms-grid-row-span: 1;\n  grid-row-end: 3;\n  -ms-grid-row: 2;\n  grid-row-start: 2;\n  -ms-grid-column-align: center;\n  justify-self: center;\n}\n.tox .tox-pop {\n  display: inline-block;\n  position: relative;\n}\n.tox .tox-pop--resizing {\n  transition: width 0.1s ease;\n}\n.tox .tox-pop--resizing .tox-toolbar,\n.tox .tox-pop--resizing .tox-toolbar__group {\n  flex-wrap: nowrap;\n}\n.tox .tox-pop--transition {\n  transition: 0.15s ease;\n  transition-property: left, right, top, bottom;\n}\n.tox .tox-pop--transition::after,\n.tox .tox-pop--transition::before {\n  transition:\n    all 0.15s,\n    visibility 0s,\n    opacity 75ms ease 75ms;\n}\n.tox .tox-pop__dialog {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n  min-width: 0;\n  overflow: hidden;\n}\n.tox .tox-pop__dialog > :not(.tox-toolbar) {\n  margin: 4px 4px 4px 8px;\n}\n.tox .tox-pop__dialog .tox-toolbar {\n  background-color: transparent;\n  margin-bottom: -1px;\n}\n.tox .tox-pop::after,\n.tox .tox-pop::before {\n  border-style: solid;\n  content: \"\";\n  display: block;\n  height: 0;\n  opacity: 1;\n  position: absolute;\n  width: 0;\n}\n.tox .tox-pop.tox-pop--inset::after,\n.tox .tox-pop.tox-pop--inset::before {\n  opacity: 0;\n  transition:\n    all 0s 0.15s,\n    visibility 0s,\n    opacity 75ms ease;\n}\n.tox .tox-pop.tox-pop--bottom::after,\n.tox .tox-pop.tox-pop--bottom::before {\n  left: 50%;\n  top: 100%;\n}\n.tox .tox-pop.tox-pop--bottom::after {\n  border-color: #fff transparent transparent transparent;\n  border-width: 8px;\n  margin-left: -8px;\n  margin-top: -1px;\n}\n.tox .tox-pop.tox-pop--bottom::before {\n  border-color: #ccc transparent transparent transparent;\n  border-width: 9px;\n  margin-left: -9px;\n}\n.tox .tox-pop.tox-pop--top::after,\n.tox .tox-pop.tox-pop--top::before {\n  left: 50%;\n  top: 0;\n  transform: translateY(-100%);\n}\n.tox .tox-pop.tox-pop--top::after {\n  border-color: transparent transparent #fff transparent;\n  border-width: 8px;\n  margin-left: -8px;\n  margin-top: 1px;\n}\n.tox .tox-pop.tox-pop--top::before {\n  border-color: transparent transparent #ccc transparent;\n  border-width: 9px;\n  margin-left: -9px;\n}\n.tox .tox-pop.tox-pop--left::after,\n.tox .tox-pop.tox-pop--left::before {\n  left: 0;\n  top: calc(50% - 1px);\n  transform: translateY(-50%);\n}\n.tox .tox-pop.tox-pop--left::after {\n  border-color: transparent #fff transparent transparent;\n  border-width: 8px;\n  margin-left: -15px;\n}\n.tox .tox-pop.tox-pop--left::before {\n  border-color: transparent #ccc transparent transparent;\n  border-width: 10px;\n  margin-left: -19px;\n}\n.tox .tox-pop.tox-pop--right::after,\n.tox .tox-pop.tox-pop--right::before {\n  left: 100%;\n  top: calc(50% + 1px);\n  transform: translateY(-50%);\n}\n.tox .tox-pop.tox-pop--right::after {\n  border-color: transparent transparent transparent #fff;\n  border-width: 8px;\n  margin-left: -1px;\n}\n.tox .tox-pop.tox-pop--right::before {\n  border-color: transparent transparent transparent #ccc;\n  border-width: 10px;\n  margin-left: -1px;\n}\n.tox .tox-pop.tox-pop--align-left::after,\n.tox .tox-pop.tox-pop--align-left::before {\n  left: 20px;\n}\n.tox .tox-pop.tox-pop--align-right::after,\n.tox .tox-pop.tox-pop--align-right::before {\n  left: calc(100% - 20px);\n}\n.tox .tox-sidebar-wrap {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  -ms-flex-preferred-size: 0;\n  min-height: 0;\n}\n.tox .tox-sidebar {\n  background-color: #fff;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.tox .tox-sidebar__slider {\n  display: flex;\n  overflow: hidden;\n}\n.tox .tox-sidebar__pane-container {\n  display: flex;\n}\n.tox .tox-sidebar__pane {\n  display: flex;\n}\n.tox .tox-sidebar--sliding-closed {\n  opacity: 0;\n}\n.tox .tox-sidebar--sliding-open {\n  opacity: 1;\n}\n.tox .tox-sidebar--sliding-growing,\n.tox .tox-sidebar--sliding-shrinking {\n  transition:\n    width 0.5s ease,\n    opacity 0.5s ease;\n}\n.tox .tox-selector {\n  background-color: #4099ff;\n  border-color: #4099ff;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  display: inline-block;\n  height: 10px;\n  position: absolute;\n  width: 10px;\n}\n.tox.tox-platform-touch .tox-selector {\n  height: 12px;\n  width: 12px;\n}\n.tox .tox-slider {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  height: 24px;\n  justify-content: center;\n  position: relative;\n}\n.tox .tox-slider__rail {\n  background-color: transparent;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  height: 10px;\n  min-width: 120px;\n  width: 100%;\n}\n.tox .tox-slider__handle {\n  background-color: #207ab7;\n  border: 2px solid #185d8c;\n  border-radius: 3px;\n  box-shadow: none;\n  height: 24px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 14px;\n}\n.tox .tox-source-code {\n  overflow: auto;\n}\n.tox .tox-spinner {\n  display: flex;\n}\n.tox .tox-spinner > div {\n  animation: tam-bouncing-dots 1.5s ease-in-out 0s infinite both;\n  background-color: rgba(34, 47, 62, 0.7);\n  border-radius: 100%;\n  height: 8px;\n  width: 8px;\n}\n.tox .tox-spinner > div:nth-child(1) {\n  animation-delay: -0.32s;\n}\n.tox .tox-spinner > div:nth-child(2) {\n  animation-delay: -0.16s;\n}\n@keyframes tam-bouncing-dots {\n  0%,\n  100%,\n  80% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n.tox:not([dir=\"rtl\"]) .tox-spinner > div:not(:first-child) {\n  margin-left: 4px;\n}\n.tox[dir=\"rtl\"] .tox-spinner > div:not(:first-child) {\n  margin-right: 4px;\n}\n.tox .tox-statusbar {\n  align-items: center;\n  background-color: #fff;\n  border-top: 1px solid #ccc;\n  color: rgba(34, 47, 62, 0.7);\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 12px;\n  font-weight: 400;\n  height: 18px;\n  overflow: hidden;\n  padding: 0 8px;\n  position: relative;\n  text-transform: uppercase;\n}\n.tox .tox-statusbar__text-container {\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n.tox .tox-statusbar__path {\n  display: flex;\n  flex: 1 1 auto;\n  margin-right: auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.tox .tox-statusbar__path > * {\n  display: inline;\n  white-space: nowrap;\n}\n.tox .tox-statusbar__wordcount {\n  flex: 0 0 auto;\n  margin-left: 1ch;\n}\n.tox .tox-statusbar a,\n.tox .tox-statusbar__path-item,\n.tox .tox-statusbar__wordcount {\n  color: rgba(34, 47, 62, 0.7);\n  text-decoration: none;\n}\n.tox .tox-statusbar a:focus:not(:disabled):not([aria-disabled=\"true\"]),\n.tox .tox-statusbar a:hover:not(:disabled):not([aria-disabled=\"true\"]),\n.tox .tox-statusbar__path-item:focus:not(:disabled):not([aria-disabled=\"true\"]),\n.tox .tox-statusbar__path-item:hover:not(:disabled):not([aria-disabled=\"true\"]),\n.tox .tox-statusbar__wordcount:focus:not(:disabled):not([aria-disabled=\"true\"]),\n.tox\n  .tox-statusbar__wordcount:hover:not(:disabled):not([aria-disabled=\"true\"]) {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.tox .tox-statusbar__resize-handle {\n  align-items: flex-end;\n  align-self: stretch;\n  cursor: nwse-resize;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  margin-left: auto;\n  margin-right: -8px;\n  padding-left: 1ch;\n}\n.tox .tox-statusbar__resize-handle svg {\n  display: block;\n  fill: rgba(34, 47, 62, 0.7);\n}\n.tox .tox-statusbar__resize-handle:focus svg {\n  background-color: #dee0e2;\n  border-radius: 1px;\n  box-shadow: 0 0 0 2px #dee0e2;\n}\n.tox:not([dir=\"rtl\"]) .tox-statusbar__path > * {\n  margin-right: 4px;\n}\n.tox:not([dir=\"rtl\"]) .tox-statusbar__branding {\n  margin-left: 1ch;\n}\n.tox[dir=\"rtl\"] .tox-statusbar {\n  flex-direction: row-reverse;\n}\n.tox[dir=\"rtl\"] .tox-statusbar__path > * {\n  margin-left: 4px;\n}\n.tox .tox-throbber {\n  z-index: 1299;\n}\n.tox .tox-throbber__busy-spinner {\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.6);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.tox .tox-tbtn {\n  align-items: center;\n  background: 0 0;\n  border: 0;\n  border-radius: 3px;\n  box-shadow: none;\n  color: #222f3e;\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  height: 34px;\n  justify-content: center;\n  margin: 2px 0 3px 0;\n  outline: 0;\n  overflow: hidden;\n  padding: 0;\n  text-transform: none;\n  width: 34px;\n}\n.tox .tox-tbtn svg {\n  display: block;\n  fill: #222f3e;\n}\n.tox .tox-tbtn.tox-tbtn-more {\n  padding-left: 5px;\n  padding-right: 5px;\n  width: inherit;\n}\n.tox .tox-tbtn:focus {\n  background: #dee0e2;\n  border: 0;\n  box-shadow: none;\n}\n.tox .tox-tbtn:hover {\n  background: #dee0e2;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-tbtn:hover svg {\n  fill: #222f3e;\n}\n.tox .tox-tbtn:active {\n  background: #c8cbcf;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-tbtn:active svg {\n  fill: #222f3e;\n}\n.tox .tox-tbtn--disabled,\n.tox .tox-tbtn--disabled:hover,\n.tox .tox-tbtn:disabled,\n.tox .tox-tbtn:disabled:hover {\n  background: 0 0;\n  border: 0;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-tbtn--disabled svg,\n.tox .tox-tbtn--disabled:hover svg,\n.tox .tox-tbtn:disabled svg,\n.tox .tox-tbtn:disabled:hover svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-tbtn--enabled,\n.tox .tox-tbtn--enabled:hover {\n  background: #c8cbcf;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-tbtn--enabled:hover > *,\n.tox .tox-tbtn--enabled > * {\n  transform: none;\n}\n.tox .tox-tbtn--enabled svg,\n.tox .tox-tbtn--enabled:hover svg {\n  fill: #222f3e;\n}\n.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) {\n  color: #222f3e;\n}\n.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) svg {\n  fill: #222f3e;\n}\n.tox .tox-tbtn:active > * {\n  transform: none;\n}\n.tox .tox-tbtn--md {\n  height: 51px;\n  width: 51px;\n}\n.tox .tox-tbtn--lg {\n  flex-direction: column;\n  height: 68px;\n  width: 68px;\n}\n.tox .tox-tbtn--return {\n  -ms-grid-row-align: stretch;\n  align-self: stretch;\n  height: unset;\n  width: 16px;\n}\n.tox .tox-tbtn--labeled {\n  padding: 0 4px;\n  width: unset;\n}\n.tox .tox-tbtn__vlabel {\n  display: block;\n  font-size: 10px;\n  font-weight: 400;\n  letter-spacing: -0.025em;\n  margin-bottom: 4px;\n  white-space: nowrap;\n}\n.tox .tox-tbtn--select {\n  margin: 2px 0 3px 0;\n  padding: 0 4px;\n  width: auto;\n}\n.tox .tox-tbtn__select-label {\n  cursor: default;\n  font-weight: 400;\n  margin: 0 4px;\n}\n.tox .tox-tbtn__select-chevron {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 16px;\n}\n.tox .tox-tbtn__select-chevron svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-tbtn--bespoke .tox-tbtn__select-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 7em;\n}\n.tox .tox-split-button {\n  border: 0;\n  border-radius: 3px;\n  box-sizing: border-box;\n  display: flex;\n  margin: 2px 0 3px 0;\n  overflow: hidden;\n}\n.tox .tox-split-button:hover {\n  box-shadow: 0 0 0 1px #dee0e2 inset;\n}\n.tox .tox-split-button:focus {\n  background: #dee0e2;\n  box-shadow: none;\n  color: #222f3e;\n}\n.tox .tox-split-button > * {\n  border-radius: 0;\n}\n.tox .tox-split-button__chevron {\n  width: 16px;\n}\n.tox .tox-split-button__chevron svg {\n  fill: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-split-button .tox-tbtn {\n  margin: 0;\n}\n.tox.tox-platform-touch .tox-split-button .tox-tbtn:first-child {\n  width: 30px;\n}\n.tox.tox-platform-touch .tox-split-button__chevron {\n  width: 20px;\n}\n.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:focus,\n.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:hover,\n.tox .tox-split-button.tox-tbtn--disabled:focus,\n.tox .tox-split-button.tox-tbtn--disabled:hover {\n  background: 0 0;\n  box-shadow: none;\n  color: rgba(34, 47, 62, 0.5);\n}\n.tox .tox-toolbar-overlord {\n  background-color: #fff;\n}\n.tox .tox-toolbar,\n.tox .tox-toolbar__overflow,\n.tox .tox-toolbar__primary {\n  background: url(\"data:image/svg+xml;charset=utf8,%3Csvg height='39px' viewBox='0 0 40 39px' width='40' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0' y='38px' width='100' height='1' fill='%23cccccc'/%3E%3C/svg%3E\")\n    left 0 top 0 #fff;\n  background-color: #fff;\n  display: flex;\n  flex: 0 0 auto;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  padding: 0 0;\n}\n.tox .tox-toolbar__overflow.tox-toolbar__overflow--closed {\n  height: 0;\n  opacity: 0;\n  padding-bottom: 0;\n  padding-top: 0;\n  visibility: hidden;\n}\n.tox .tox-toolbar__overflow--growing {\n  transition:\n    height 0.3s ease,\n    opacity 0.2s linear 0.1s;\n}\n.tox .tox-toolbar__overflow--shrinking {\n  transition:\n    opacity 0.3s ease,\n    height 0.2s linear 0.1s,\n    visibility 0s linear 0.3s;\n}\n.tox .tox-menubar + .tox-toolbar,\n.tox .tox-menubar + .tox-toolbar-overlord .tox-toolbar__primary {\n  border-top: 1px solid #ccc;\n  margin-top: -1px;\n}\n.tox .tox-toolbar--scrolling {\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n.tox .tox-pop .tox-toolbar {\n  border-width: 0;\n}\n.tox .tox-toolbar--no-divider {\n  background-image: none;\n}\n.tox-tinymce:not(.tox-tinymce-inline)\n  .tox-editor-header:not(:first-child)\n  .tox-toolbar-overlord:first-child\n  .tox-toolbar__primary,\n.tox-tinymce:not(.tox-tinymce-inline)\n  .tox-editor-header:not(:first-child)\n  .tox-toolbar:first-child {\n  border-top: 1px solid #ccc;\n}\n.tox.tox-tinymce-aux .tox-toolbar__overflow {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n.tox .tox-toolbar__group {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 0;\n  padding: 0 4px 0 4px;\n}\n.tox .tox-toolbar__group--pull-right {\n  margin-left: auto;\n}\n.tox .tox-toolbar--scrolling .tox-toolbar__group {\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n}\n.tox:not([dir=\"rtl\"]) .tox-toolbar__group:not(:last-of-type) {\n  border-right: 1px solid #ccc;\n}\n.tox[dir=\"rtl\"] .tox-toolbar__group:not(:last-of-type) {\n  border-left: 1px solid #ccc;\n}\n.tox .tox-tooltip {\n  display: inline-block;\n  padding: 8px;\n  position: relative;\n}\n.tox .tox-tooltip__body {\n  background-color: #222f3e;\n  border-radius: 3px;\n  box-shadow: 0 2px 4px rgba(34, 47, 62, 0.3);\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  padding: 4px 8px;\n  text-transform: none;\n}\n.tox .tox-tooltip__arrow {\n  position: absolute;\n}\n.tox .tox-tooltip--down .tox-tooltip__arrow {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #222f3e;\n  bottom: 0;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n}\n.tox .tox-tooltip--up .tox-tooltip__arrow {\n  border-bottom: 8px solid #222f3e;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  left: 50%;\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n}\n.tox .tox-tooltip--right .tox-tooltip__arrow {\n  border-bottom: 8px solid transparent;\n  border-left: 8px solid #222f3e;\n  border-top: 8px solid transparent;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-tooltip--left .tox-tooltip__arrow {\n  border-bottom: 8px solid transparent;\n  border-right: 8px solid #222f3e;\n  border-top: 8px solid transparent;\n  left: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-well {\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  padding: 8px;\n  width: 100%;\n}\n.tox .tox-well > :first-child {\n  margin-top: 0;\n}\n.tox .tox-well > :last-child {\n  margin-bottom: 0;\n}\n.tox .tox-well > :only-child {\n  margin: 0;\n}\n.tox .tox-custom-editor {\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  display: flex;\n  flex: 1;\n  position: relative;\n}\n.tox .tox-dialog-loading::before {\n  background-color: rgba(0, 0, 0, 0.5);\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  z-index: 1000;\n}\n.tox .tox-tab {\n  cursor: pointer;\n}\n.tox .tox-dialog__content-js {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-dialog__body-content .tox-collection {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-image-tools-edit-panel {\n  height: 60px;\n}\n.tox .tox-image-tools__sidebar {\n  height: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
